import * as e from "react";
import t, { useEffect as n, useState as a, useRef as r, Fragment as o } from "react";
import i from "prop-types";
import { _ as l, a as s, u as d, b as m, c as p, d as v, e as b, f as g, g as h, h as y } from "./hooks-47503321.js";
export { u as useKeyDown, f as useLocalStorage, c as useOverflowX } from "./hooks-47503321.js";
import * as E from "react-dom";
import { createPortal as N } from "react-dom";
var w,
    x = {
  exports: {}
};
w = x, function () {
  var e = {}.hasOwnProperty;

  function t() {
    for (var n = [], a = 0; a < arguments.length; a++) {
      var r = arguments[a];

      if (r) {
        var o = l(r);
        if ("string" === o || "number" === o) n.push(r);else if (Array.isArray(r)) {
          if (r.length) {
            var i = t.apply(null, r);
            i && n.push(i);
          }
        } else if ("object" === o) if (r.toString === Object.prototype.toString) for (var s in r) e.call(r, s) && r[s] && n.push(s);else n.push(r.toString());
      }
    }

    return n.join(" ");
  }

  w.exports ? (t.default = t, w.exports = t) : window.classNames = t;
}();
var k = x.exports;

function C(e, t, n, a) {
  void 0 === a && "development" === process.env.NODE_ENV && console.warn("The ".concat(e, " ").concat(t, " '").concat(n, "' is not defined"));
}

var D = {
  name: i.string.isRequired,
  color: i.string,
  noWrapper: i.bool
},
    O = {
  arrowDown: {
    baseName: "arrowLeft",
    rotation: 270
  },
  arrowLeft: {
    baseName: "arrowLeft"
  },
  arrowRight: {
    baseName: "arrowLeft",
    rotation: 180
  },
  arrowUp: {
    baseName: "arrowLeft",
    rotation: 90
  },
  bar: {
    baseName: "bar"
  },
  blank: {
    baseName: ""
  },
  calendar: {
    baseName: "calendar"
  },
  check: {
    baseName: "check"
  },
  checkCircle: {
    baseName: "checkCircle"
  },
  chevronDown: {
    baseName: "chevronDown"
  },
  chevronLeft: {
    baseName: "chevronDown",
    rotation: 90
  },
  chevronLeftDouble: {
    baseName: "chevronDouble"
  },
  chevronRight: {
    baseName: "chevronDown",
    rotation: 270
  },
  chevronRightDouble: {
    baseName: "chevronDouble",
    rotation: 180
  },
  chevronUp: {
    baseName: "chevronDown",
    rotation: 180
  },
  clipboard: {
    baseName: "clipboard"
  },
  closeX: {
    baseName: "close"
  },
  closeXSmall: {
    baseName: "closeXSmall"
  },
  column: {
    baseName: "bar",
    rotation: 270
  },
  company: {
    baseName: "company"
  },
  connections: {
    baseName: "connections"
  },
  copy: {
    baseName: "copy"
  },
  creatives: {
    baseName: "creatives"
  },
  cxIcon: {
    baseName: "cxIcon"
  },
  dashboard: {
    baseName: "dashboard"
  },
  download: {
    baseName: "download"
  },
  exclamation: {
    baseName: "exclamation"
  },
  exclamationCircle: {
    baseName: "exclamationCircle"
  },
  exclamationTriangle: {
    baseName: "exclamationTriangle"
  },
  expand: {
    baseName: "expand"
  },
  externalLink: {
    baseName: "externalLink"
  },
  filter: {
    baseName: "filter"
  },
  flag: {
    baseName: "flag"
  },
  flagFilled: {
    baseName: "flagFilled"
  },
  guidelines: {
    baseName: "guidelines"
  },
  helpCenter: {
    baseName: "helpCenter"
  },
  info: {
    baseName: "info"
  },
  infoCircle: {
    baseName: "infoCircle"
  },
  line: {
    baseName: "line"
  },
  link: {
    baseName: "link"
  },
  lock: {
    baseName: "lock"
  },
  minimize: {
    baseName: "minimize"
  },
  moreDots: {
    baseName: "moreDots"
  },
  pause: {
    baseName: "pause"
  },
  play: {
    baseName: "play"
  },
  plus: {
    baseName: "plus"
  },
  preflight: {
    baseName: "preflight"
  },
  processing: {
    baseName: "processing"
  },
  productionEfficiency: {
    baseName: "productionEfficiency"
  },
  questionCircle: {
    baseName: "questionCircle"
  },
  reporting: {
    baseName: "reporting"
  },
  search: {
    baseName: "search"
  },
  settings: {
    baseName: "settings"
  },
  settingsGear: {
    baseName: "settingsGear"
  },
  smallArrowDown: {
    baseName: "smallArrowUp",
    rotation: 180
  },
  smallArrowUp: {
    baseName: "smallArrowUp"
  },
  soundOn: {
    baseName: "soundOn"
  },
  soundOff: {
    baseName: "soundOff"
  },
  spinner: {
    baseName: "spinner"
  },
  thumbsUp: {
    baseName: "thumbsUp"
  },
  userPreferences: {
    baseName: "userPreferences"
  },
  x: {
    baseName: "x"
  },
  xCircle: {
    baseName: "xCircle"
  }
},
    R = {
  current: null,
  darkPurple: "--midnight-700",
  green: "--green-700",
  grey: "--grey-700",
  orange: "--semantic-orange",
  purple: "--purple-500",
  red: "--semantic-red",
  white: "--white"
};

function T(e) {
  var n = e.color,
      a = e.name,
      r = e.noWrapper,
      o = function (e, t) {
    var n,
        a = R[t],
        r = (n = a) ? "var(".concat(n, ")") : null,
        o = O[e],
        i = null == o ? void 0 : o.baseName,
        l = null != o && o.rotation ? "rotate(".concat(o.rotation, "deg)") : null;
    return C("Icon", "color", t, a), C("Icon", "name", e, i), [i, {
      fill: r,
      transform: l
    }];
  }(a, n),
      i = s(o, 2),
      l = i[0],
      c = i[1],
      u = /*#__PURE__*/t.createElement("span", {
    className: "icon",
    style: c
  }, /*#__PURE__*/t.createElement("svg", {
    "aria-label": a,
    height: "100%",
    role: "img",
    width: "100%"
  }, /*#__PURE__*/t.createElement("use", {
    xlinkHref: "#icon-".concat(l)
  })));

  return r ? u : /*#__PURE__*/t.createElement("div", {
    className: "icon-wrapper"
  }, u);
}

T.propTypes = D, T.defaultProps = {
  color: "grey",
  noWrapper: !1
};
var L = ["accent", "destructive", "primary", "round", "secondary", "tertiary", "text"],
    S = {
  ariaExpanded: i.bool,
  ariaLabel: i.string,
  disabled: i.bool,
  form: i.string,
  iconLeft: i.string,
  iconRight: i.string,
  label: i.string,
  testId: i.string,
  type: i.oneOf(["button", "submit"]),
  url: i.string,
  variant: i.oneOf(L),
  onClick: i.func
},
    q = {
  ariaExpanded: void 0,
  ariaLabel: "",
  disabled: !1,
  form: void 0,
  iconLeft: void 0,
  iconRight: void 0,
  label: void 0,
  onClick: void 0,
  testId: void 0,
  type: "button",
  url: void 0,
  variant: "primary"
};

function I(e) {
  return e ? /*#__PURE__*/t.createElement("span", {
    className: "button-icon"
  }, /*#__PURE__*/t.createElement(T, {
    color: "current",
    name: e,
    noWrapper: !0
  })) : null;
}

var P = /*#__PURE__*/t.forwardRef(function (e, n) {
  var a = e.ariaExpanded,
      r = e.ariaLabel,
      o = e.disabled,
      i = e.form,
      l = e.iconLeft,
      s = e.iconRight,
      c = e.label,
      u = e.onClick,
      d = e.testId,
      m = e.type,
      p = e.url,
      f = e.variant,
      v = k("button", "button--".concat(f), {
    "t-button": "destructive" !== f,
    "t-button-bold": "destructive" === f,
    "button--square": l && !c
  }),
      b = /*#__PURE__*/t.createElement(t.Fragment, null, I(l), c, I(s));
  return p && !o ? /*#__PURE__*/t.createElement("a", {
    className: v,
    href: p,
    onClick: u
  }, b) : /*#__PURE__*/t.createElement("button", {
    ref: n,
    "aria-expanded": a,
    "aria-label": r || c || "Button",
    className: v,
    "data-testid": d,
    disabled: o,
    form: i,
    type: m,
    onClick: u
  }, b);
});
P.propTypes = S, P.defaultProps = q;
var A = {
  label: i.string.isRequired,
  disabled: i.bool,
  testId: i.string,
  url: i.string,
  onClick: i.func
},
    U = {
  disabled: !1,
  onClick: void 0,
  testId: void 0,
  url: void 0
};

function z(e) {
  var n = e.disabled,
      a = e.label,
      r = e.onClick,
      o = e.testId,
      i = e.url;
  return /*#__PURE__*/t.createElement(P, {
    disabled: n,
    iconLeft: "plus",
    label: a,
    testId: o,
    url: i,
    variant: "accent",
    onClick: r
  });
}

z.propTypes = A, z.defaultProps = U;
var B = {
  color: i.oneOf(["custom", "purple"]),
  size: i.oneOf(["custom", "medium"])
};

function M(e) {
  var n = e.color,
      a = e.size,
      r = k("spinner", {
    "spinner--purple": "purple" === n,
    "spinner--medium": "medium" === a
  });
  return /*#__PURE__*/t.createElement("div", {
    className: r
  }, /*#__PURE__*/t.createElement(T, {
    color: "current",
    name: "spinner"
  }));
}

M.propTypes = B, M.defaultProps = {
  color: "purple",
  size: "medium"
};
var F = {
  active: i.bool,
  ariaLabel: i.string,
  disabled: i.bool,
  form: i.string,
  iconLeft: i.string,
  iconRight: i.string,
  label: i.string,
  type: i.string,
  url: i.string,
  variant: i.oneOf(L),
  onClick: i.func
},
    j = {
  active: !1,
  ariaLabel: void 0,
  disabled: void 0,
  form: void 0,
  iconLeft: void 0,
  iconRight: void 0,
  label: void 0,
  onClick: void 0,
  type: "button",
  url: void 0,
  variant: "primary"
};

function Y(e) {
  var n = e.active,
      a = e.ariaLabel,
      r = e.disabled,
      o = e.form,
      i = e.iconLeft,
      l = e.iconRight,
      s = e.label,
      c = e.onClick,
      u = e.type,
      d = e.url,
      m = e.variant,
      p = k("actionButton-spinner", {
    "actionButton-spinner--primary": "primary" === m,
    "actionButton-spinner--secondary": "secondary" === m,
    "actionButton-spinner--tertiary": "tertiary" === m
  });
  return /*#__PURE__*/t.createElement("div", {
    className: "actionButton"
  }, /*#__PURE__*/t.createElement(P, {
    ariaLabel: a,
    disabled: n || r,
    form: o,
    iconLeft: i,
    iconRight: l,
    label: s,
    type: u,
    url: d,
    variant: m,
    onClick: c
  }), n && /*#__PURE__*/t.createElement("div", {
    className: "actionButton-active"
  }, /*#__PURE__*/t.createElement("div", {
    className: p
  }, /*#__PURE__*/t.createElement(M, {
    color: "custom",
    size: "custom"
  }))));
}

Y.propTypes = F, Y.defaultProps = j;
var G = ["custom", "full", "medium"],
    H = {
  isOpen: i.bool.isRequired,
  onClose: i.func.isRequired,
  ariaLabel: i.string,
  children: i.node,
  footer: i.node,
  header: i.node,
  padding: i.bool,
  size: i.oneOf(G)
},
    W = {
  ariaLabel: "Modal",
  children: void 0,
  footer: void 0,
  header: void 0,
  padding: !0,
  size: "custom"
};

function V(e) {
  var a = e.ariaLabel,
      r = e.children,
      o = e.footer,
      i = e.header,
      l = e.isOpen,
      s = e.onClose,
      c = e.padding,
      u = e.size;
  d("Escape", s), n(function () {
    document.body.style.overflow = l ? "hidden" : "auto";
  }, [l, s]);
  var m = k("dsmodal-card", {
    "dsmodal--medium": "medium" === u,
    "dsmodal--full": "full" === u,
    "dsmodal--padding": c
  });
  return l ? /*#__PURE__*/t.createElement("div", {
    className: "dsmodal-backdrop"
  }, /*#__PURE__*/t.createElement("div", {
    "aria-label": a,
    "aria-modal": "true",
    className: m,
    role: "dialog"
  }, i || c ? i ? /*#__PURE__*/t.createElement("div", {
    className: "dsmodal-header"
  }, i) : /*#__PURE__*/t.createElement("div", {
    className: "dsmodal-spacer"
  }) : null, /*#__PURE__*/t.createElement("div", {
    className: "dsmodal-body"
  }, r), o || c ? o ? /*#__PURE__*/t.createElement("div", {
    className: "dsmodal-footer"
  }, o) : /*#__PURE__*/t.createElement("div", {
    className: "dsmodal-spacer"
  }) : null)) : null;
}

V.propTypes = H, V.defaultProps = W;
var _ = {
  children: i.node,
  className: i.string,
  padding: i.bool
},
    K = {
  children: void 0,
  className: void 0,
  padding: !0
};

function X(e) {
  var n = e.children,
      a = e.className,
      r = e.padding,
      o = k("card", a, {
    "card-padding": r
  });
  return /*#__PURE__*/t.createElement("div", {
    className: o
  }, n);
}

X.propTypes = _, X.defaultProps = K;
var Q = {
  ariaLabel: i.string,
  autoComplete: i.string,
  checked: i.bool,
  disabled: i.bool,
  label: i.node,
  name: i.string,
  testId: i.string,
  onChange: i.func
},
    J = {
  ariaLabel: "",
  autoComplete: "off",
  checked: !1,
  disabled: !1,
  label: void 0,
  name: void 0,
  onChange: void 0,
  testId: void 0
};

function $(e) {
  var n = e.ariaLabel,
      a = e.autoComplete,
      r = e.checked,
      o = e.disabled,
      i = e.label,
      l = e.name,
      s = e.onChange,
      c = e.testId,
      u = k("checkbox", "t-label-1", {
    "checkbox--disabled": o
  });
  return /*#__PURE__*/t.createElement("label", {
    className: u
  }, /*#__PURE__*/t.createElement("input", {
    "aria-label": n || i || "Checkbox",
    autoComplete: a,
    checked: r,
    className: "checkbox-input",
    "data-testid": c,
    disabled: o,
    name: l,
    type: "checkbox",
    onChange: s
  }), /*#__PURE__*/t.createElement("div", {
    className: "checkbox-box"
  }, /*#__PURE__*/t.createElement("div", {
    className: "checkbox-focus"
  }), /*#__PURE__*/t.createElement("div", {
    className: "checkbox-border"
  }), /*#__PURE__*/t.createElement("div", {
    className: "checkbox-icon"
  }, /*#__PURE__*/t.createElement(T, {
    color: "white",
    name: "check"
  }))), /*#__PURE__*/t.createElement("div", {
    className: "checkbox-label"
  }, i));
}

$.propTypes = Q, $.defaultProps = J;
var Z = {
  label: i.string.isRequired,
  color: i.oneOf(["blue", "green", "grey", "orange", "purple", "red"]),
  icon: i.string,
  onClick: i.func,
  onRemove: i.func
},
    ee = {
  color: "grey",
  icon: void 0,
  onClick: void 0,
  onRemove: void 0
};

function te(e) {
  return e ? /*#__PURE__*/t.createElement("span", {
    className: "tag-icon"
  }, /*#__PURE__*/t.createElement(T, {
    color: "current",
    name: e
  })) : null;
}

function ne(e) {
  var n = e.label,
      a = e.color,
      r = e.icon,
      o = e.onClick,
      i = e.onRemove,
      l = k("tag--clickable", "t-body-1", {
    "tag--hoverable": void 0 !== o
  }),
      s = k("tag-button", "t-body-1", "tag--".concat(a), {
    "tag-button--removable": void 0 !== i,
    "tag--icon": r
  }),
      c = k("tag-removeButton", "tag--".concat(a));
  return /*#__PURE__*/t.createElement("div", {
    className: "tag"
  }, /*#__PURE__*/t.createElement("div", {
    className: l
  }, /*#__PURE__*/t.createElement("button", {
    className: s,
    type: "button",
    onClick: o
  }, te(r), /*#__PURE__*/t.createElement("div", {
    className: "tag-label"
  }, n)), i && /*#__PURE__*/t.createElement("button", {
    "aria-label": "Remove ".concat(n, " tag"),
    className: c,
    type: "button",
    onClick: i
  }, te("closeXSmall"))));
}

ne.propTypes = Z, ne.defaultProps = ee;
var ae = {
  testId: i.string,
  onClick: i.func
},
    re = {
  onClick: void 0,
  testId: void 0
};

function oe(e) {
  var n = e.onClick,
      a = e.testId;
  return /*#__PURE__*/t.createElement(P, {
    ariaLabel: "Close",
    iconLeft: "closeX",
    testId: a,
    variant: "round",
    onClick: n
  });
}

oe.propTypes = ae, oe.defaultProps = re;

var ie = function (e) {
  return e.reduce(function (e, t) {
    var n = t[0],
        a = t[1];
    return e[n] = a, e;
  }, {});
},
    le = "undefined" != typeof window && window.document && window.document.createElement ? e.useLayoutEffect : e.useEffect,
    se = "top",
    ce = "bottom",
    ue = "right",
    de = "left",
    me = [se, ce, ue, de],
    pe = me.reduce(function (e, t) {
  return e.concat([t + "-start", t + "-end"]);
}, []),
    fe = [].concat(me, ["auto"]).reduce(function (e, t) {
  return e.concat([t, t + "-start", t + "-end"]);
}, []),
    ve = ["beforeRead", "read", "afterRead", "beforeMain", "main", "afterMain", "beforeWrite", "write", "afterWrite"];

function be(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}

function ge(e) {
  if (null == e) return window;

  if ("[object Window]" !== e.toString()) {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }

  return e;
}

function he(e) {
  return e instanceof ge(e).Element || e instanceof Element;
}

function ye(e) {
  return e instanceof ge(e).HTMLElement || e instanceof HTMLElement;
}

function Ee(e) {
  return "undefined" != typeof ShadowRoot && (e instanceof ge(e).ShadowRoot || e instanceof ShadowRoot);
}

var Ne = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: function (e) {
    var t = e.state;
    Object.keys(t.elements).forEach(function (e) {
      var n = t.styles[e] || {},
          a = t.attributes[e] || {},
          r = t.elements[e];
      ye(r) && be(r) && (Object.assign(r.style, n), Object.keys(a).forEach(function (e) {
        var t = a[e];
        !1 === t ? r.removeAttribute(e) : r.setAttribute(e, !0 === t ? "" : t);
      }));
    });
  },
  effect: function (e) {
    var t = e.state,
        n = {
      popper: {
        position: t.options.strategy,
        left: "0",
        top: "0",
        margin: "0"
      },
      arrow: {
        position: "absolute"
      },
      reference: {}
    };
    return Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow), function () {
      Object.keys(t.elements).forEach(function (e) {
        var a = t.elements[e],
            r = t.attributes[e] || {},
            o = Object.keys(t.styles.hasOwnProperty(e) ? t.styles[e] : n[e]).reduce(function (e, t) {
          return e[t] = "", e;
        }, {});
        ye(a) && be(a) && (Object.assign(a.style, o), Object.keys(r).forEach(function (e) {
          a.removeAttribute(e);
        }));
      });
    };
  },
  requires: ["computeStyles"]
};

function we(e) {
  return e.split("-")[0];
}

var xe = Math.max,
    ke = Math.min,
    Ce = Math.round;

function De() {
  var e = navigator.userAgentData;
  return null != e && e.brands && Array.isArray(e.brands) ? e.brands.map(function (e) {
    return e.brand + "/" + e.version;
  }).join(" ") : navigator.userAgent;
}

function Oe() {
  return !/^((?!chrome|android).)*safari/i.test(De());
}

function Re(e, t, n) {
  void 0 === t && (t = !1), void 0 === n && (n = !1);
  var a = e.getBoundingClientRect(),
      r = 1,
      o = 1;
  t && ye(e) && (r = e.offsetWidth > 0 && Ce(a.width) / e.offsetWidth || 1, o = e.offsetHeight > 0 && Ce(a.height) / e.offsetHeight || 1);
  var i = (he(e) ? ge(e) : window).visualViewport,
      l = !Oe() && n,
      s = (a.left + (l && i ? i.offsetLeft : 0)) / r,
      c = (a.top + (l && i ? i.offsetTop : 0)) / o,
      u = a.width / r,
      d = a.height / o;
  return {
    width: u,
    height: d,
    top: c,
    right: s + u,
    bottom: c + d,
    left: s,
    x: s,
    y: c
  };
}

function Te(e) {
  var t = Re(e),
      n = e.offsetWidth,
      a = e.offsetHeight;
  return Math.abs(t.width - n) <= 1 && (n = t.width), Math.abs(t.height - a) <= 1 && (a = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: n,
    height: a
  };
}

function Le(e, t) {
  var n = t.getRootNode && t.getRootNode();
  if (e.contains(t)) return !0;

  if (n && Ee(n)) {
    var a = t;

    do {
      if (a && e.isSameNode(a)) return !0;
      a = a.parentNode || a.host;
    } while (a);
  }

  return !1;
}

function Se(e) {
  return ge(e).getComputedStyle(e);
}

function qe(e) {
  return ["table", "td", "th"].indexOf(be(e)) >= 0;
}

function Ie(e) {
  return ((he(e) ? e.ownerDocument : e.document) || window.document).documentElement;
}

function Pe(e) {
  return "html" === be(e) ? e : e.assignedSlot || e.parentNode || (Ee(e) ? e.host : null) || Ie(e);
}

function Ae(e) {
  return ye(e) && "fixed" !== Se(e).position ? e.offsetParent : null;
}

function Ue(e) {
  for (var t = ge(e), n = Ae(e); n && qe(n) && "static" === Se(n).position;) n = Ae(n);

  return n && ("html" === be(n) || "body" === be(n) && "static" === Se(n).position) ? t : n || function (e) {
    var t = /firefox/i.test(De());
    if (/Trident/i.test(De()) && ye(e) && "fixed" === Se(e).position) return null;
    var n = Pe(e);

    for (Ee(n) && (n = n.host); ye(n) && ["html", "body"].indexOf(be(n)) < 0;) {
      var a = Se(n);
      if ("none" !== a.transform || "none" !== a.perspective || "paint" === a.contain || -1 !== ["transform", "perspective"].indexOf(a.willChange) || t && "filter" === a.willChange || t && a.filter && "none" !== a.filter) return n;
      n = n.parentNode;
    }

    return null;
  }(e) || t;
}

function ze(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}

function Be(e, t, n) {
  return xe(e, ke(t, n));
}

function Me(e) {
  return Object.assign({}, {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  }, e);
}

function Fe(e, t) {
  return t.reduce(function (t, n) {
    return t[n] = e, t;
  }, {});
}

var je = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: function (e) {
    var t,
        n = e.state,
        a = e.name,
        r = e.options,
        o = n.elements.arrow,
        i = n.modifiersData.popperOffsets,
        l = we(n.placement),
        s = ze(l),
        c = [de, ue].indexOf(l) >= 0 ? "height" : "width";

    if (o && i) {
      var u = function (e, t) {
        return Me("number" != typeof (e = "function" == typeof e ? e(Object.assign({}, t.rects, {
          placement: t.placement
        })) : e) ? e : Fe(e, me));
      }(r.padding, n),
          d = Te(o),
          m = "y" === s ? se : de,
          p = "y" === s ? ce : ue,
          f = n.rects.reference[c] + n.rects.reference[s] - i[s] - n.rects.popper[c],
          v = i[s] - n.rects.reference[s],
          b = Ue(o),
          g = b ? "y" === s ? b.clientHeight || 0 : b.clientWidth || 0 : 0,
          h = f / 2 - v / 2,
          y = u[m],
          E = g - d[c] - u[p],
          N = g / 2 - d[c] / 2 + h,
          w = Be(y, N, E),
          x = s;

      n.modifiersData[a] = ((t = {})[x] = w, t.centerOffset = w - N, t);
    }
  },
  effect: function (e) {
    var t = e.state,
        n = e.options.element,
        a = void 0 === n ? "[data-popper-arrow]" : n;
    null != a && ("string" != typeof a || (a = t.elements.popper.querySelector(a))) && Le(t.elements.popper, a) && (t.elements.arrow = a);
  },
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};

function Ye(e) {
  return e.split("-")[1];
}

var Ge = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};

function He(e) {
  var t,
      n = e.popper,
      a = e.popperRect,
      r = e.placement,
      o = e.variation,
      i = e.offsets,
      l = e.position,
      s = e.gpuAcceleration,
      c = e.adaptive,
      u = e.roundOffsets,
      d = e.isFixed,
      m = i.x,
      p = void 0 === m ? 0 : m,
      f = i.y,
      v = void 0 === f ? 0 : f,
      b = "function" == typeof u ? u({
    x: p,
    y: v
  }) : {
    x: p,
    y: v
  };
  p = b.x, v = b.y;
  var g = i.hasOwnProperty("x"),
      h = i.hasOwnProperty("y"),
      y = de,
      E = se,
      N = window;

  if (c) {
    var w = Ue(n),
        x = "clientHeight",
        k = "clientWidth";
    if (w === ge(n) && "static" !== Se(w = Ie(n)).position && "absolute" === l && (x = "scrollHeight", k = "scrollWidth"), r === se || (r === de || r === ue) && "end" === o) E = ce, v -= (d && w === N && N.visualViewport ? N.visualViewport.height : w[x]) - a.height, v *= s ? 1 : -1;
    if (r === de || (r === se || r === ce) && "end" === o) y = ue, p -= (d && w === N && N.visualViewport ? N.visualViewport.width : w[k]) - a.width, p *= s ? 1 : -1;
  }

  var C,
      D = Object.assign({
    position: l
  }, c && Ge),
      O = !0 === u ? function (e, t) {
    var n = e.x,
        a = e.y,
        r = t.devicePixelRatio || 1;
    return {
      x: Ce(n * r) / r || 0,
      y: Ce(a * r) / r || 0
    };
  }({
    x: p,
    y: v
  }, ge(n)) : {
    x: p,
    y: v
  };
  return p = O.x, v = O.y, s ? Object.assign({}, D, ((C = {})[E] = h ? "0" : "", C[y] = g ? "0" : "", C.transform = (N.devicePixelRatio || 1) <= 1 ? "translate(" + p + "px, " + v + "px)" : "translate3d(" + p + "px, " + v + "px, 0)", C)) : Object.assign({}, D, ((t = {})[E] = h ? v + "px" : "", t[y] = g ? p + "px" : "", t.transform = "", t));
}

var We = {
  passive: !0
};
var Ve = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};

function _e(e) {
  return e.replace(/left|right|bottom|top/g, function (e) {
    return Ve[e];
  });
}

var Ke = {
  start: "end",
  end: "start"
};

function Xe(e) {
  return e.replace(/start|end/g, function (e) {
    return Ke[e];
  });
}

function Qe(e) {
  var t = ge(e);
  return {
    scrollLeft: t.pageXOffset,
    scrollTop: t.pageYOffset
  };
}

function Je(e) {
  return Re(Ie(e)).left + Qe(e).scrollLeft;
}

function $e(e) {
  var t = Se(e),
      n = t.overflow,
      a = t.overflowX,
      r = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + r + a);
}

function Ze(e) {
  return ["html", "body", "#document"].indexOf(be(e)) >= 0 ? e.ownerDocument.body : ye(e) && $e(e) ? e : Ze(Pe(e));
}

function et(e, t) {
  var n;
  void 0 === t && (t = []);
  var a = Ze(e),
      r = a === (null == (n = e.ownerDocument) ? void 0 : n.body),
      o = ge(a),
      i = r ? [o].concat(o.visualViewport || [], $e(a) ? a : []) : a,
      l = t.concat(i);
  return r ? l : l.concat(et(Pe(i)));
}

function tt(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}

function nt(e, t, n) {
  return "viewport" === t ? tt(function (e, t) {
    var n = ge(e),
        a = Ie(e),
        r = n.visualViewport,
        o = a.clientWidth,
        i = a.clientHeight,
        l = 0,
        s = 0;

    if (r) {
      o = r.width, i = r.height;
      var c = Oe();
      (c || !c && "fixed" === t) && (l = r.offsetLeft, s = r.offsetTop);
    }

    return {
      width: o,
      height: i,
      x: l + Je(e),
      y: s
    };
  }(e, n)) : he(t) ? function (e, t) {
    var n = Re(e, !1, "fixed" === t);
    return n.top = n.top + e.clientTop, n.left = n.left + e.clientLeft, n.bottom = n.top + e.clientHeight, n.right = n.left + e.clientWidth, n.width = e.clientWidth, n.height = e.clientHeight, n.x = n.left, n.y = n.top, n;
  }(t, n) : tt(function (e) {
    var t,
        n = Ie(e),
        a = Qe(e),
        r = null == (t = e.ownerDocument) ? void 0 : t.body,
        o = xe(n.scrollWidth, n.clientWidth, r ? r.scrollWidth : 0, r ? r.clientWidth : 0),
        i = xe(n.scrollHeight, n.clientHeight, r ? r.scrollHeight : 0, r ? r.clientHeight : 0),
        l = -a.scrollLeft + Je(e),
        s = -a.scrollTop;
    return "rtl" === Se(r || n).direction && (l += xe(n.clientWidth, r ? r.clientWidth : 0) - o), {
      width: o,
      height: i,
      x: l,
      y: s
    };
  }(Ie(e)));
}

function at(e, t, n, a) {
  var r = "clippingParents" === t ? function (e) {
    var t = et(Pe(e)),
        n = ["absolute", "fixed"].indexOf(Se(e).position) >= 0 && ye(e) ? Ue(e) : e;
    return he(n) ? t.filter(function (e) {
      return he(e) && Le(e, n) && "body" !== be(e);
    }) : [];
  }(e) : [].concat(t),
      o = [].concat(r, [n]),
      i = o[0],
      l = o.reduce(function (t, n) {
    var r = nt(e, n, a);
    return t.top = xe(r.top, t.top), t.right = ke(r.right, t.right), t.bottom = ke(r.bottom, t.bottom), t.left = xe(r.left, t.left), t;
  }, nt(e, i, a));
  return l.width = l.right - l.left, l.height = l.bottom - l.top, l.x = l.left, l.y = l.top, l;
}

function rt(e) {
  var t,
      n = e.reference,
      a = e.element,
      r = e.placement,
      o = r ? we(r) : null,
      i = r ? Ye(r) : null,
      l = n.x + n.width / 2 - a.width / 2,
      s = n.y + n.height / 2 - a.height / 2;

  switch (o) {
    case se:
      t = {
        x: l,
        y: n.y - a.height
      };
      break;

    case ce:
      t = {
        x: l,
        y: n.y + n.height
      };
      break;

    case ue:
      t = {
        x: n.x + n.width,
        y: s
      };
      break;

    case de:
      t = {
        x: n.x - a.width,
        y: s
      };
      break;

    default:
      t = {
        x: n.x,
        y: n.y
      };
  }

  var c = o ? ze(o) : null;

  if (null != c) {
    var u = "y" === c ? "height" : "width";

    switch (i) {
      case "start":
        t[c] = t[c] - (n[u] / 2 - a[u] / 2);
        break;

      case "end":
        t[c] = t[c] + (n[u] / 2 - a[u] / 2);
    }
  }

  return t;
}

function ot(e, t) {
  void 0 === t && (t = {});
  var n = t,
      a = n.placement,
      r = void 0 === a ? e.placement : a,
      o = n.strategy,
      i = void 0 === o ? e.strategy : o,
      l = n.boundary,
      s = void 0 === l ? "clippingParents" : l,
      c = n.rootBoundary,
      u = void 0 === c ? "viewport" : c,
      d = n.elementContext,
      m = void 0 === d ? "popper" : d,
      p = n.altBoundary,
      f = void 0 !== p && p,
      v = n.padding,
      b = void 0 === v ? 0 : v,
      g = Me("number" != typeof b ? b : Fe(b, me)),
      h = "popper" === m ? "reference" : "popper",
      y = e.rects.popper,
      E = e.elements[f ? h : m],
      N = at(he(E) ? E : E.contextElement || Ie(e.elements.popper), s, u, i),
      w = Re(e.elements.reference),
      x = rt({
    reference: w,
    element: y,
    strategy: "absolute",
    placement: r
  }),
      k = tt(Object.assign({}, y, x)),
      C = "popper" === m ? k : w,
      D = {
    top: N.top - C.top + g.top,
    bottom: C.bottom - N.bottom + g.bottom,
    left: N.left - C.left + g.left,
    right: C.right - N.right + g.right
  },
      O = e.modifiersData.offset;

  if ("popper" === m && O) {
    var R = O[r];
    Object.keys(D).forEach(function (e) {
      var t = [ue, ce].indexOf(e) >= 0 ? 1 : -1,
          n = [se, ce].indexOf(e) >= 0 ? "y" : "x";
      D[e] += R[n] * t;
    });
  }

  return D;
}

function it(e, t) {
  void 0 === t && (t = {});
  var n = t,
      a = n.placement,
      r = n.boundary,
      o = n.rootBoundary,
      i = n.padding,
      l = n.flipVariations,
      s = n.allowedAutoPlacements,
      c = void 0 === s ? fe : s,
      u = Ye(a),
      d = u ? l ? pe : pe.filter(function (e) {
    return Ye(e) === u;
  }) : me,
      m = d.filter(function (e) {
    return c.indexOf(e) >= 0;
  });
  0 === m.length && (m = d);
  var p = m.reduce(function (t, n) {
    return t[n] = ot(e, {
      placement: n,
      boundary: r,
      rootBoundary: o,
      padding: i
    })[we(n)], t;
  }, {});
  return Object.keys(p).sort(function (e, t) {
    return p[e] - p[t];
  });
}

var lt = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: function (e) {
    var t = e.state,
        n = e.options,
        a = e.name;

    if (!t.modifiersData[a]._skip) {
      for (var r = n.mainAxis, o = void 0 === r || r, i = n.altAxis, l = void 0 === i || i, s = n.fallbackPlacements, c = n.padding, u = n.boundary, d = n.rootBoundary, m = n.altBoundary, p = n.flipVariations, f = void 0 === p || p, v = n.allowedAutoPlacements, b = t.options.placement, g = we(b), h = s || (g === b || !f ? [_e(b)] : function (e) {
        if ("auto" === we(e)) return [];

        var t = _e(e);

        return [Xe(e), t, Xe(t)];
      }(b)), y = [b].concat(h).reduce(function (e, n) {
        return e.concat("auto" === we(n) ? it(t, {
          placement: n,
          boundary: u,
          rootBoundary: d,
          padding: c,
          flipVariations: f,
          allowedAutoPlacements: v
        }) : n);
      }, []), E = t.rects.reference, N = t.rects.popper, w = new Map(), x = !0, k = y[0], C = 0; C < y.length; C++) {
        var D = y[C],
            O = we(D),
            R = "start" === Ye(D),
            T = [se, ce].indexOf(O) >= 0,
            L = T ? "width" : "height",
            S = ot(t, {
          placement: D,
          boundary: u,
          rootBoundary: d,
          altBoundary: m,
          padding: c
        }),
            q = T ? R ? ue : de : R ? ce : se;
        E[L] > N[L] && (q = _e(q));

        var I = _e(q),
            P = [];

        if (o && P.push(S[O] <= 0), l && P.push(S[q] <= 0, S[I] <= 0), P.every(function (e) {
          return e;
        })) {
          k = D, x = !1;
          break;
        }

        w.set(D, P);
      }

      if (x) for (var A = function (e) {
        var t = y.find(function (t) {
          var n = w.get(t);
          if (n) return n.slice(0, e).every(function (e) {
            return e;
          });
        });
        if (t) return k = t, "break";
      }, U = f ? 3 : 1; U > 0; U--) {
        if ("break" === A(U)) break;
      }
      t.placement !== k && (t.modifiersData[a]._skip = !0, t.placement = k, t.reset = !0);
    }
  },
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};

function st(e, t, n) {
  return void 0 === n && (n = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - n.y,
    right: e.right - t.width + n.x,
    bottom: e.bottom - t.height + n.y,
    left: e.left - t.width - n.x
  };
}

function ct(e) {
  return [se, ue, ce, de].some(function (t) {
    return e[t] >= 0;
  });
}

var ut = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: function (e) {
    var t = e.state,
        n = e.options,
        a = e.name,
        r = n.offset,
        o = void 0 === r ? [0, 0] : r,
        i = fe.reduce(function (e, n) {
      return e[n] = function (e, t, n) {
        var a = we(e),
            r = [de, se].indexOf(a) >= 0 ? -1 : 1,
            o = "function" == typeof n ? n(Object.assign({}, t, {
          placement: e
        })) : n,
            i = o[0],
            l = o[1];
        return i = i || 0, l = (l || 0) * r, [de, ue].indexOf(a) >= 0 ? {
          x: l,
          y: i
        } : {
          x: i,
          y: l
        };
      }(n, t.rects, o), e;
    }, {}),
        l = i[t.placement],
        s = l.x,
        c = l.y;
    null != t.modifiersData.popperOffsets && (t.modifiersData.popperOffsets.x += s, t.modifiersData.popperOffsets.y += c), t.modifiersData[a] = i;
  }
};
var dt = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: function (e) {
    var t = e.state,
        n = e.options,
        a = e.name,
        r = n.mainAxis,
        o = void 0 === r || r,
        i = n.altAxis,
        l = void 0 !== i && i,
        s = n.boundary,
        c = n.rootBoundary,
        u = n.altBoundary,
        d = n.padding,
        m = n.tether,
        p = void 0 === m || m,
        f = n.tetherOffset,
        v = void 0 === f ? 0 : f,
        b = ot(t, {
      boundary: s,
      rootBoundary: c,
      padding: d,
      altBoundary: u
    }),
        g = we(t.placement),
        h = Ye(t.placement),
        y = !h,
        E = ze(g),
        N = "x" === E ? "y" : "x",
        w = t.modifiersData.popperOffsets,
        x = t.rects.reference,
        k = t.rects.popper,
        C = "function" == typeof v ? v(Object.assign({}, t.rects, {
      placement: t.placement
    })) : v,
        D = "number" == typeof C ? {
      mainAxis: C,
      altAxis: C
    } : Object.assign({
      mainAxis: 0,
      altAxis: 0
    }, C),
        O = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null,
        R = {
      x: 0,
      y: 0
    };

    if (w) {
      if (o) {
        var T,
            L = "y" === E ? se : de,
            S = "y" === E ? ce : ue,
            q = "y" === E ? "height" : "width",
            I = w[E],
            P = I + b[L],
            A = I - b[S],
            U = p ? -k[q] / 2 : 0,
            z = "start" === h ? x[q] : k[q],
            B = "start" === h ? -k[q] : -x[q],
            M = t.elements.arrow,
            F = p && M ? Te(M) : {
          width: 0,
          height: 0
        },
            j = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : {
          top: 0,
          right: 0,
          bottom: 0,
          left: 0
        },
            Y = j[L],
            G = j[S],
            H = Be(0, x[q], F[q]),
            W = y ? x[q] / 2 - U - H - Y - D.mainAxis : z - H - Y - D.mainAxis,
            V = y ? -x[q] / 2 + U + H + G + D.mainAxis : B + H + G + D.mainAxis,
            _ = t.elements.arrow && Ue(t.elements.arrow),
            K = _ ? "y" === E ? _.clientTop || 0 : _.clientLeft || 0 : 0,
            X = null != (T = null == O ? void 0 : O[E]) ? T : 0,
            Q = I + V - X,
            J = Be(p ? ke(P, I + W - X - K) : P, I, p ? xe(A, Q) : A);

        w[E] = J, R[E] = J - I;
      }

      if (l) {
        var $,
            Z = "x" === E ? se : de,
            ee = "x" === E ? ce : ue,
            te = w[N],
            ne = "y" === N ? "height" : "width",
            ae = te + b[Z],
            re = te - b[ee],
            oe = -1 !== [se, de].indexOf(g),
            ie = null != ($ = null == O ? void 0 : O[N]) ? $ : 0,
            le = oe ? ae : te - x[ne] - k[ne] - ie + D.altAxis,
            me = oe ? te + x[ne] + k[ne] - ie - D.altAxis : re,
            pe = p && oe ? function (e, t, n) {
          var a = Be(e, t, n);
          return a > n ? n : a;
        }(le, te, me) : Be(p ? le : ae, te, p ? me : re);
        w[N] = pe, R[N] = pe - te;
      }

      t.modifiersData[a] = R;
    }
  },
  requiresIfExists: ["offset"]
};

function mt(e, t, n) {
  void 0 === n && (n = !1);

  var a,
      r,
      o = ye(t),
      i = ye(t) && function (e) {
    var t = e.getBoundingClientRect(),
        n = Ce(t.width) / e.offsetWidth || 1,
        a = Ce(t.height) / e.offsetHeight || 1;
    return 1 !== n || 1 !== a;
  }(t),
      l = Ie(t),
      s = Re(e, i, n),
      c = {
    scrollLeft: 0,
    scrollTop: 0
  },
      u = {
    x: 0,
    y: 0
  };

  return (o || !o && !n) && (("body" !== be(t) || $e(l)) && (c = (a = t) !== ge(a) && ye(a) ? {
    scrollLeft: (r = a).scrollLeft,
    scrollTop: r.scrollTop
  } : Qe(a)), ye(t) ? ((u = Re(t, !0)).x += t.clientLeft, u.y += t.clientTop) : l && (u.x = Je(l))), {
    x: s.left + c.scrollLeft - u.x,
    y: s.top + c.scrollTop - u.y,
    width: s.width,
    height: s.height
  };
}

function pt(e) {
  var t = new Map(),
      n = new Set(),
      a = [];

  function r(e) {
    n.add(e.name), [].concat(e.requires || [], e.requiresIfExists || []).forEach(function (e) {
      if (!n.has(e)) {
        var a = t.get(e);
        a && r(a);
      }
    }), a.push(e);
  }

  return e.forEach(function (e) {
    t.set(e.name, e);
  }), e.forEach(function (e) {
    n.has(e.name) || r(e);
  }), a;
}

var ft = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};

function vt() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];

  return !t.some(function (e) {
    return !(e && "function" == typeof e.getBoundingClientRect);
  });
}

function bt(e) {
  void 0 === e && (e = {});
  var t = e,
      n = t.defaultModifiers,
      a = void 0 === n ? [] : n,
      r = t.defaultOptions,
      o = void 0 === r ? ft : r;
  return function (e, t, n) {
    void 0 === n && (n = o);
    var r,
        i,
        l = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, ft, o),
      modifiersData: {},
      elements: {
        reference: e,
        popper: t
      },
      attributes: {},
      styles: {}
    },
        s = [],
        c = !1,
        u = {
      state: l,
      setOptions: function (n) {
        var r = "function" == typeof n ? n(l.options) : n;
        d(), l.options = Object.assign({}, o, l.options, r), l.scrollParents = {
          reference: he(e) ? et(e) : e.contextElement ? et(e.contextElement) : [],
          popper: et(t)
        };

        var i,
            c,
            m = function (e) {
          var t = pt(e);
          return ve.reduce(function (e, n) {
            return e.concat(t.filter(function (e) {
              return e.phase === n;
            }));
          }, []);
        }((i = [].concat(a, l.options.modifiers), c = i.reduce(function (e, t) {
          var n = e[t.name];
          return e[t.name] = n ? Object.assign({}, n, t, {
            options: Object.assign({}, n.options, t.options),
            data: Object.assign({}, n.data, t.data)
          }) : t, e;
        }, {}), Object.keys(c).map(function (e) {
          return c[e];
        })));

        return l.orderedModifiers = m.filter(function (e) {
          return e.enabled;
        }), l.orderedModifiers.forEach(function (e) {
          var t = e.name,
              n = e.options,
              a = void 0 === n ? {} : n,
              r = e.effect;

          if ("function" == typeof r) {
            var o = r({
              state: l,
              name: t,
              instance: u,
              options: a
            }),
                i = function () {};

            s.push(o || i);
          }
        }), u.update();
      },
      forceUpdate: function () {
        if (!c) {
          var e = l.elements,
              t = e.reference,
              n = e.popper;

          if (vt(t, n)) {
            l.rects = {
              reference: mt(t, Ue(n), "fixed" === l.options.strategy),
              popper: Te(n)
            }, l.reset = !1, l.placement = l.options.placement, l.orderedModifiers.forEach(function (e) {
              return l.modifiersData[e.name] = Object.assign({}, e.data);
            });

            for (var a = 0; a < l.orderedModifiers.length; a++) if (!0 !== l.reset) {
              var r = l.orderedModifiers[a],
                  o = r.fn,
                  i = r.options,
                  s = void 0 === i ? {} : i,
                  d = r.name;
              "function" == typeof o && (l = o({
                state: l,
                options: s,
                name: d,
                instance: u
              }) || l);
            } else l.reset = !1, a = -1;
          }
        }
      },
      update: (r = function () {
        return new Promise(function (e) {
          u.forceUpdate(), e(l);
        });
      }, function () {
        return i || (i = new Promise(function (e) {
          Promise.resolve().then(function () {
            i = void 0, e(r());
          });
        })), i;
      }),
      destroy: function () {
        d(), c = !0;
      }
    };
    if (!vt(e, t)) return u;

    function d() {
      s.forEach(function (e) {
        return e();
      }), s = [];
    }

    return u.setOptions(n).then(function (e) {
      !c && n.onFirstUpdate && n.onFirstUpdate(e);
    }), u;
  };
}

var gt = bt({
  defaultModifiers: [{
    name: "eventListeners",
    enabled: !0,
    phase: "write",
    fn: function () {},
    effect: function (e) {
      var t = e.state,
          n = e.instance,
          a = e.options,
          r = a.scroll,
          o = void 0 === r || r,
          i = a.resize,
          l = void 0 === i || i,
          s = ge(t.elements.popper),
          c = [].concat(t.scrollParents.reference, t.scrollParents.popper);
      return o && c.forEach(function (e) {
        e.addEventListener("scroll", n.update, We);
      }), l && s.addEventListener("resize", n.update, We), function () {
        o && c.forEach(function (e) {
          e.removeEventListener("scroll", n.update, We);
        }), l && s.removeEventListener("resize", n.update, We);
      };
    },
    data: {}
  }, {
    name: "popperOffsets",
    enabled: !0,
    phase: "read",
    fn: function (e) {
      var t = e.state,
          n = e.name;
      t.modifiersData[n] = rt({
        reference: t.rects.reference,
        element: t.rects.popper,
        strategy: "absolute",
        placement: t.placement
      });
    },
    data: {}
  }, {
    name: "computeStyles",
    enabled: !0,
    phase: "beforeWrite",
    fn: function (e) {
      var t = e.state,
          n = e.options,
          a = n.gpuAcceleration,
          r = void 0 === a || a,
          o = n.adaptive,
          i = void 0 === o || o,
          l = n.roundOffsets,
          s = void 0 === l || l,
          c = {
        placement: we(t.placement),
        variation: Ye(t.placement),
        popper: t.elements.popper,
        popperRect: t.rects.popper,
        gpuAcceleration: r,
        isFixed: "fixed" === t.options.strategy
      };
      null != t.modifiersData.popperOffsets && (t.styles.popper = Object.assign({}, t.styles.popper, He(Object.assign({}, c, {
        offsets: t.modifiersData.popperOffsets,
        position: t.options.strategy,
        adaptive: i,
        roundOffsets: s
      })))), null != t.modifiersData.arrow && (t.styles.arrow = Object.assign({}, t.styles.arrow, He(Object.assign({}, c, {
        offsets: t.modifiersData.arrow,
        position: "absolute",
        adaptive: !1,
        roundOffsets: s
      })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
        "data-popper-placement": t.placement
      });
    },
    data: {}
  }, Ne, ut, lt, dt, je, {
    name: "hide",
    enabled: !0,
    phase: "main",
    requiresIfExists: ["preventOverflow"],
    fn: function (e) {
      var t = e.state,
          n = e.name,
          a = t.rects.reference,
          r = t.rects.popper,
          o = t.modifiersData.preventOverflow,
          i = ot(t, {
        elementContext: "reference"
      }),
          l = ot(t, {
        altBoundary: !0
      }),
          s = st(i, a),
          c = st(l, r, o),
          u = ct(s),
          d = ct(c);
      t.modifiersData[n] = {
        referenceClippingOffsets: s,
        popperEscapeOffsets: c,
        isReferenceHidden: u,
        hasPopperEscaped: d
      }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
        "data-popper-reference-hidden": u,
        "data-popper-escaped": d
      });
    }
  }]
}),
    ht = "undefined" != typeof Element,
    yt = "function" == typeof Map,
    Et = "function" == typeof Set,
    Nt = "function" == typeof ArrayBuffer && !!ArrayBuffer.isView;

function wt(e, t) {
  if (e === t) return !0;

  if (e && t && "object" == l(e) && "object" == l(t)) {
    if (e.constructor !== t.constructor) return !1;
    var n, a, r, o;

    if (Array.isArray(e)) {
      if ((n = e.length) != t.length) return !1;

      for (a = n; 0 != a--;) if (!wt(e[a], t[a])) return !1;

      return !0;
    }

    if (yt && e instanceof Map && t instanceof Map) {
      if (e.size !== t.size) return !1;

      for (o = e.entries(); !(a = o.next()).done;) if (!t.has(a.value[0])) return !1;

      for (o = e.entries(); !(a = o.next()).done;) if (!wt(a.value[1], t.get(a.value[0]))) return !1;

      return !0;
    }

    if (Et && e instanceof Set && t instanceof Set) {
      if (e.size !== t.size) return !1;

      for (o = e.entries(); !(a = o.next()).done;) if (!t.has(a.value[0])) return !1;

      return !0;
    }

    if (Nt && ArrayBuffer.isView(e) && ArrayBuffer.isView(t)) {
      if ((n = e.length) != t.length) return !1;

      for (a = n; 0 != a--;) if (e[a] !== t[a]) return !1;

      return !0;
    }

    if (e.constructor === RegExp) return e.source === t.source && e.flags === t.flags;
    if (e.valueOf !== Object.prototype.valueOf && "function" == typeof e.valueOf && "function" == typeof t.valueOf) return e.valueOf() === t.valueOf();
    if (e.toString !== Object.prototype.toString && "function" == typeof e.toString && "function" == typeof t.toString) return e.toString() === t.toString();
    if ((n = (r = Object.keys(e)).length) !== Object.keys(t).length) return !1;

    for (a = n; 0 != a--;) if (!Object.prototype.hasOwnProperty.call(t, r[a])) return !1;

    if (ht && e instanceof Element) return !1;

    for (a = n; 0 != a--;) if (("_owner" !== r[a] && "__v" !== r[a] && "__o" !== r[a] || !e.$$typeof) && !wt(e[r[a]], t[r[a]])) return !1;

    return !0;
  }

  return e != e && t != t;
}

var xt = function (e, t) {
  try {
    return wt(e, t);
  } catch (e) {
    if ((e.message || "").match(/stack|recursion/i)) return console.warn("react-fast-compare cannot handle circular refs"), !1;
    throw e;
  }
},
    kt = [],
    Ct = function (t, n, a) {
  void 0 === a && (a = {});
  var r = e.useRef(null),
      o = {
    onFirstUpdate: a.onFirstUpdate,
    placement: a.placement || "bottom",
    strategy: a.strategy || "absolute",
    modifiers: a.modifiers || kt
  },
      i = e.useState({
    styles: {
      popper: {
        position: o.strategy,
        left: "0",
        top: "0"
      },
      arrow: {
        position: "absolute"
      }
    },
    attributes: {}
  }),
      l = i[0],
      s = i[1],
      c = e.useMemo(function () {
    return {
      name: "updateState",
      enabled: !0,
      phase: "write",
      fn: function (e) {
        var t = e.state,
            n = Object.keys(t.elements);
        E.flushSync(function () {
          s({
            styles: ie(n.map(function (e) {
              return [e, t.styles[e] || {}];
            })),
            attributes: ie(n.map(function (e) {
              return [e, t.attributes[e]];
            }))
          });
        });
      },
      requires: ["computeStyles"]
    };
  }, []),
      u = e.useMemo(function () {
    var e = {
      onFirstUpdate: o.onFirstUpdate,
      placement: o.placement,
      strategy: o.strategy,
      modifiers: [].concat(o.modifiers, [c, {
        name: "applyStyles",
        enabled: !1
      }])
    };
    return xt(r.current, e) ? r.current || e : (r.current = e, e);
  }, [o.onFirstUpdate, o.placement, o.strategy, o.modifiers, c]),
      d = e.useRef();
  return le(function () {
    d.current && d.current.setOptions(u);
  }, [u]), le(function () {
    if (null != t && null != n) {
      var e = (a.createPopper || gt)(t, n, u);
      return d.current = e, function () {
        e.destroy(), d.current = null;
      };
    }
  }, [t, n, a.createPopper]), {
    state: d.current ? d.current.state : null,
    styles: l.styles,
    attributes: l.attributes,
    update: d.current ? d.current.update : null,
    forceUpdate: d.current ? d.current.forceUpdate : null
  };
};

process.env.NODE_ENV;
var Dt = {
  children: i.node
};

function Ot(e) {
  var t = e.children,
      n = document.getElementById("portal-root");
  return /*#__PURE__*/N(t, n);
}

Ot.propTypes = Dt;
var Rt = i.shape({
  type: i.oneOf(["default", "error", "success"]),
  value: i.string
}),
    Tt = {
  messages: i.arrayOf(Rt)
},
    Lt = {
  messages: void 0
};

function St(e) {
  return "error" === e ? "exclamationCircle" : "checkCircle";
}

function qt(e) {
  var n = e.type,
      a = e.value,
      r = k("t-label-1", "helperText-row", {
    "helperText-default": "default" === n || !n,
    "helperText-error": "error" === n,
    "helperText-success": "success" === n
  });
  return /*#__PURE__*/t.createElement("div", {
    key: a,
    className: r
  }, /*#__PURE__*/t.createElement("div", {
    className: "helperText-icon"
  }, /*#__PURE__*/t.createElement(T, {
    color: "helperText-current",
    name: St(n)
  })), a);
}

function It(e) {
  var n = e.messages;
  return n ? /*#__PURE__*/t.createElement("div", {
    className: "helperText-container"
  }, n.map(qt)) : null;
}

It.propTypes = Tt, It.defaultProps = Lt;
var Pt = ["small", "medium", "large"],
    At = {
  value: i.oneOfType([i.number, i.string]).isRequired,
  ariaLabel: i.string,
  disabled: i.bool,
  form: i.string,
  helperText: i.arrayOf(Rt),
  isError: i.bool,
  label: i.node,
  max: i.number,
  maxLength: i.number,
  min: i.number,
  minLength: i.number,
  name: i.string,
  placeholder: i.string,
  placeholderIcon: i.string,
  required: i.bool,
  size: i.oneOf(Pt),
  step: i.oneOfType([i.number, i.string]),
  testId: i.string,
  type: i.string,
  onChange: i.func,
  onKeyDown: i.func
},
    Ut = {
  ariaLabel: "",
  disabled: !1,
  form: void 0,
  helperText: void 0,
  isError: !1,
  label: void 0,
  max: void 0,
  maxLength: void 0,
  min: void 0,
  minLength: void 0,
  name: void 0,
  onChange: void 0,
  onKeyDown: void 0,
  placeholder: void 0,
  placeholderIcon: void 0,
  required: !1,
  size: "small",
  step: 1,
  testId: void 0,
  type: "text"
},
    zt = /*#__PURE__*/t.forwardRef(function (e, n) {
  var a = e.ariaLabel,
      r = e.disabled,
      o = e.form,
      i = e.helperText,
      l = e.isError,
      s = e.label,
      c = e.max,
      u = e.maxLength,
      d = e.min,
      m = e.minLength,
      p = e.name,
      f = e.onChange,
      v = e.onKeyDown,
      b = e.placeholder,
      g = e.placeholderIcon,
      h = e.required,
      y = e.size,
      E = e.step,
      N = e.testId,
      w = e.type,
      x = e.value,
      C = k("textInput-container", {
    "textInput-container--small": "small" === y,
    "textInput-container--medium": "medium" === y,
    "textInput-container--large": "large" === y,
    "textInput-container--disabled": r,
    "textInput-container--error": l
  }),
      D = "" !== x;
  return /*#__PURE__*/t.createElement("div", {
    className: "textInput"
  }, /*#__PURE__*/t.createElement("label", null, s && /*#__PURE__*/t.createElement("div", {
    className: "textInput-label t-caption-1"
  }, s), /*#__PURE__*/t.createElement("div", {
    className: C
  }, /*#__PURE__*/t.createElement("input", {
    ref: n,
    "aria-label": a || s || "Text box",
    autoComplete: "off",
    className: "textInput-input t-body-1",
    "data-testid": N,
    disabled: r,
    form: o,
    max: c,
    maxLength: u,
    min: d,
    minLength: m,
    name: p,
    placeholder: b,
    required: h,
    step: E,
    type: w,
    value: x,
    onChange: function (e) {
      return null == f ? void 0 : f(e.target.value);
    },
    onKeyDown: function (e) {
      return null == v ? void 0 : v(e.key);
    }
  }), /*#__PURE__*/t.createElement("div", {
    className: "textInput-icon"
  }, !D && g && /*#__PURE__*/t.createElement("div", {
    className: "textInput-placeholderIcon"
  }, /*#__PURE__*/t.createElement(T, {
    color: "current",
    name: g,
    noWrapper: !0
  })), D && !r && /*#__PURE__*/t.createElement(P, {
    ariaLabel: "Clear",
    iconLeft: "closeX",
    variant: "tertiary",
    onClick: function () {
      return null == f ? void 0 : f("");
    }
  }))), /*#__PURE__*/t.createElement(It, {
    messages: i
  })));
});
zt.propTypes = At, zt.defaultProps = Ut;
var Bt = {
  value: i.string.isRequired,
  onChange: i.func.isRequired,
  ariaLabel: i.string,
  disabled: i.bool,
  placeholder: i.string,
  size: i.oneOf(Pt),
  testId: i.string,
  onKeyDown: i.func
},
    Mt = {
  ariaLabel: "",
  disabled: !1,
  onKeyDown: void 0,
  placeholder: "Search",
  size: "medium",
  testId: void 0
},
    Ft = /*#__PURE__*/t.forwardRef(function (e, n) {
  var a = e.ariaLabel,
      r = e.disabled,
      o = e.onChange,
      i = e.onKeyDown,
      l = e.placeholder,
      s = e.size,
      c = e.testId,
      u = e.value;
  return /*#__PURE__*/t.createElement(zt, {
    ref: n,
    ariaLabel: a || "Search",
    disabled: r,
    placeholder: l,
    placeholderIcon: "search",
    size: s,
    testId: c,
    value: u,
    onChange: o,
    onKeyDown: i
  });
});
Ft.propTypes = Bt, Ft.defaultProps = Mt;
var jt = /*#__PURE__*/t.createElement(T, {
  name: "infoCircle"
}),
    Yt = {
  ariaLabelSubject: i.string,
  breakAll: i.bool,
  children: i.node,
  direction: i.oneOf(["top", "bottom", "left", "right"]),
  label: i.string
},
    Gt = {
  ariaLabelSubject: null,
  breakAll: !1,
  children: null,
  direction: "top",
  label: void 0
};

function Ht(e) {
  var r,
      o,
      i = e.ariaLabelSubject,
      l = e.breakAll,
      c = e.children,
      u = e.direction,
      d = e.label,
      p = a(0),
      f = s(p, 2),
      v = f[0],
      b = f[1],
      g = a(!1),
      h = s(g, 2),
      y = h[0],
      E = h[1],
      N = a(null),
      w = s(N, 2),
      x = w[0],
      C = w[1],
      D = a(null),
      O = s(D, 2),
      R = O[0],
      T = O[1];
  n(function () {
    var e, t, n;
    x && b((e = "--cx-tooltip-caret-size", t = getComputedStyle(x).getPropertyValue(e), n = parseInt(t), Number.isInteger(n) ? n : null));
  }, [x]);
  var L = Ct(x, R, {
    modifiers: [{
      name: "offset",
      options: {
        offset: [0, v]
      }
    }],
    placement: u
  }),
      S = L.styles,
      q = L.attributes,
      I = null !== (r = null === (o = q.popper) || void 0 === o ? void 0 : o["data-popper-placement"]) && void 0 !== r ? r : u,
      P = y && Boolean(d),
      A = k("tooltip", "tooltip--".concat(I), "t-subtitle", {
    "tooltip--breakAll": l
  });
  return /*#__PURE__*/t.createElement("div", {
    ref: C,
    "aria-label": "".concat(null != i ? i : "More", " information"),
    className: "tooltip-target",
    role: "button",
    tabIndex: 0,
    onBlur: function () {
      return E(!1);
    },
    onFocus: function () {
      return E(!0);
    },
    onKeyDown: function (e) {
      "Escape" === e.key && (e.preventDefault(), y && E(!1));
    },
    onMouseEnter: function () {
      return E(!0);
    },
    onMouseLeave: function () {
      return E(!1);
    }
  }, P && /*#__PURE__*/t.createElement(Ot, null, /*#__PURE__*/t.createElement("div", m({
    ref: T,
    className: A,
    style: S.popper
  }, q.popper), d)), null != c ? c : jt);
}

Ht.propTypes = Yt, Ht.defaultProps = Gt;
var Wt = {
  text: i.oneOfType([i.string, i.number]).isRequired,
  breakAll: i.bool,
  className: i.string,
  size: i.oneOf(["medium", "custom"])
},
    Vt = {
  breakAll: !1,
  className: void 0,
  size: "medium"
};

function _t(e) {
  var n = e.breakAll,
      a = e.className,
      o = e.size,
      i = e.text,
      l = r(null),
      s = p(l) ? i : null,
      c = k("maxWidthText", a, {
    "maxWidthText--medium": "medium" === o
  });
  return /*#__PURE__*/t.createElement(Ht, {
    ariaLabelSubject: i,
    breakAll: n,
    label: s
  }, /*#__PURE__*/t.createElement("div", {
    ref: l,
    className: c
  }, i));
}

_t.propTypes = Wt, _t.defaultProps = Vt;
var Kt = {
  label: i.string.isRequired,
  disabled: i.bool,
  group: i.bool,
  icon: i.string,
  newTab: i.bool,
  selected: i.bool,
  testId: i.string,
  url: i.string,
  value: i.node,
  onClick: i.func
},
    Xt = ["top-left", "top-right", "bottom-left", "bottom-right"],
    Qt = ["small", "medium", "large"],
    Jt = {
  options: i.arrayOf(i.shape(Kt)).isRequired,
  show: i.bool.isRequired,
  onClose: i.func.isRequired,
  className: i.string,
  id: i.string,
  label: i.string,
  multiple: i.bool,
  parentRef: i.shape({
    current: i.instanceOf(Element)
  }),
  position: i.oneOf(Xt),
  search: i.bool,
  size: i.oneOf(Qt),
  useTooltips: i.bool,
  onActiveDescendantChange: i.func
},
    $t = {
  className: void 0,
  id: void 0,
  label: void 0,
  multiple: !1,
  onActiveDescendantChange: void 0,
  parentRef: void 0,
  position: "bottom-left",
  search: !1,
  size: "small",
  useTooltips: !0
};

function Zt(e) {
  switch (e) {
    case "top-right":
      return "top-end";

    case "top-left":
      return "top-start";

    case "bottom-right":
      return "bottom-end";

    default:
      return "bottom-start";
  }
}

function en(e, t) {
  if (!t) return e;
  return e.reduce(function (e, n) {
    return n.group ? [].concat(b(e), [n]) : (a = n.label, r = t, a.toLowerCase().includes(r.toLowerCase()) ? [].concat(b(e), [n]) : e);
    var a, r;
  }, []);
}

function tn(e) {
  var o = e.className,
      i = e.id,
      l = e.label,
      c = e.multiple,
      u = e.onClose,
      p = e.options,
      f = e.parentRef,
      b = e.position,
      g = e.search,
      h = e.onActiveDescendantChange,
      y = e.show,
      E = e.size,
      N = e.useTooltips,
      w = r(null),
      x = r([]),
      C = a([]),
      D = s(C, 2),
      O = D[0],
      R = D[1],
      L = a(""),
      S = s(L, 2),
      q = S[0],
      I = S[1],
      P = a(null),
      A = s(P, 2),
      U = A[0],
      z = A[1],
      B = a(-1),
      M = s(B, 2),
      F = M[0],
      j = M[1],
      Y = function () {
    I(""), j(-1), null == h || h(null), u();
  },
      G = function (e) {
    e.preventDefault(), y && ("ArrowDown" === e.key ? j(function (e) {
      return e === x.current.length - 1 ? -1 : e + 1;
    }) : "ArrowUp" === e.key && j(function (e) {
      return -1 === e ? x.current.length - 1 : 0 === e ? -1 : e - 1;
    }));
  };

  n(function () {
    var e, t;
    -1 === F ? (null === (e = w.current) || void 0 === e || e.focus(), null == h || h(null)) : (null === (t = x.current[F]) || void 0 === t || t.focus(), null == h || h("menu-item-".concat(F)));
  }, [F]), n(function () {
    x.current.splice(O.length);
  }, [O]), n(function () {
    R(en(p, q));
  }, [p]), d("Escape", Y), d("ArrowDown", G), d("ArrowUp", G), v(Y, [U, f.current]);
  var H = Ct(f.current, U, {
    modifiers: [{
      name: "offset",
      options: {
        offset: [0, 8]
      }
    }],
    placement: Zt(b)
  }),
      W = H.styles,
      V = H.attributes;
  if (!y) return null;

  var _ = k({
    "menu--small": "small" === E,
    "menu--medium": "medium" === E,
    "menu--large": "large" === E
  }),
      K = k("menu", "u-elevation-1", _, o);

  var X = O.map(function (e, n) {
    return e.group ? function (e) {
      return /*#__PURE__*/t.createElement("div", {
        key: e,
        className: "t-body-1 menuGroup"
      }, /*#__PURE__*/t.createElement("div", {
        className: "menuOption-content"
      }, /*#__PURE__*/t.createElement("div", {
        className: "t-caption-1"
      }, e)));
    }(e.label) : function (e, n) {
      var a = e.disabled,
          r = e.label,
          o = e.icon,
          i = e.newTab,
          l = e.onClick,
          s = e.selected,
          u = e.testId,
          d = e.url,
          m = k("menuOption", "t-body-1", {
        "menuOption--disabled": a,
        "menuOption--multiple": c,
        "menuOption--selected": s && c,
        "menuOption--icon": o
      }),
          p = /*#__PURE__*/t.createElement("div", {
        className: "menuOption-content"
      }, o && /*#__PURE__*/t.createElement(T, {
        name: o
      }), s && c && /*#__PURE__*/t.createElement(T, {
        name: "check"
      }), N ? /*#__PURE__*/t.createElement(_t, {
        text: r
      }) : r),
          f = function () {
        a || (l && l(), c || Y());
      };

      return d ? /*#__PURE__*/t.createElement("a", {
        key: r,
        ref: function (e) {
          x.current[n] = e;
        },
        "aria-label": r,
        "aria-selected": s,
        className: m,
        "data-testid": u,
        href: d,
        id: "menu-item-".concat(n),
        rel: "noreferrer",
        role: "option",
        tabIndex: -1,
        target: i ? "_blank" : "_self",
        onClick: f
      }, p) : /*#__PURE__*/t.createElement("button", {
        key: r,
        ref: function (e) {
          x.current[n] = e;
        },
        "aria-label": r,
        "aria-selected": s,
        className: m,
        "data-testid": u,
        id: "menu-item-".concat(n),
        role: "option",
        tabIndex: -1,
        type: "button",
        onClick: f
      }, p);
    }(e, n);
  }),
      Q = /*#__PURE__*/t.createElement(t.Fragment, null, g && /*#__PURE__*/t.createElement("div", {
    className: "menuSearch"
  }, /*#__PURE__*/t.createElement(Ft, {
    ref: w,
    ariaLabel: "Search ".concat(l),
    value: q,
    onChange: function (e) {
      I(e), R(en(p, e));
    }
  })), /*#__PURE__*/t.createElement("div", {
    role: "group"
  }, X));
  return /*#__PURE__*/t.createElement(Ot, null, /*#__PURE__*/t.createElement("div", m({
    ref: z,
    "aria-label": l,
    "aria-multiselectable": c,
    className: K,
    id: i,
    role: "listbox",
    style: W.popper,
    tabIndex: -1
  }, V.popper), Q));
}

tn.propTypes = Jt, tn.defaultProps = $t;
var nn = {
  options: i.arrayOf(i.shape(Kt)).isRequired,
  disabled: i.bool,
  label: i.string,
  menuPosition: i.oneOf(Xt),
  menuSize: i.oneOf(Qt),
  menuTestId: i.string,
  testId: i.string,
  onClick: i.func
},
    an = {
  disabled: !1,
  label: void 0,
  menuPosition: "bottom-right",
  menuSize: "small",
  menuTestId: void 0,
  onClick: void 0,
  testId: void 0
};

function rn(e) {
  var n = e.disabled,
      o = e.label,
      i = e.menuPosition,
      l = e.menuSize,
      c = e.menuTestId,
      u = e.onClick,
      d = e.options,
      m = e.testId,
      p = r(),
      f = a(!1),
      v = s(f, 2),
      b = v[0],
      g = v[1];
  return /*#__PURE__*/t.createElement("div", {
    className: "comboButton"
  }, /*#__PURE__*/t.createElement("div", {
    className: "comboButton-action"
  }, /*#__PURE__*/t.createElement(P, {
    disabled: n,
    label: o,
    testId: m,
    variant: "secondary",
    onClick: function () {
      null == u || u(), g(!1);
    }
  })), /*#__PURE__*/t.createElement("div", {
    ref: p,
    className: "comboButton-dropdown"
  }, /*#__PURE__*/t.createElement(P, {
    disabled: n,
    iconLeft: "chevronDown",
    testId: c,
    variant: "secondary",
    onClick: function () {
      return g(!b);
    }
  })), /*#__PURE__*/t.createElement(tn, {
    options: d,
    parentRef: p,
    position: i,
    show: b,
    size: l,
    onClose: function () {
      return g(!1);
    }
  }));
}

rn.propTypes = nn, rn.defaultProps = an;
var on = {
  text: i.string.isRequired,
  testId: i.string,
  onClick: i.func
},
    ln = {
  onClick: void 0,
  testId: void 0
};

function sn(e) {
  var n = e.onClick,
      a = e.testId,
      r = e.text;
  return /*#__PURE__*/t.createElement(P, {
    ariaLabel: "Copy",
    iconLeft: "copy",
    testId: a,
    variant: "round",
    onClick: function () {
      navigator.clipboard.writeText(r), null == n || n();
    }
  });
}

sn.propTypes = on, sn.defaultProps = ln;
var cn = {
  animate: i.bool
};

function un(e) {
  var n = e.animate,
      a = k("skeleton--dataViz", {
    "skeleton--dataViz--animated": n
  });
  return /*#__PURE__*/t.createElement("div", {
    className: "skeleton"
  }, /*#__PURE__*/t.createElement("div", {
    className: a
  }, /*#__PURE__*/t.createElement("div", {
    className: "skeleton-bar"
  }), /*#__PURE__*/t.createElement("div", {
    className: "skeleton-bar"
  }), /*#__PURE__*/t.createElement("div", {
    className: "skeleton-bar"
  }), /*#__PURE__*/t.createElement("div", {
    className: "skeleton-bar"
  }), /*#__PURE__*/t.createElement("div", {
    className: "skeleton-bar"
  }), /*#__PURE__*/t.createElement("div", {
    className: "skeleton-bar"
  }), /*#__PURE__*/t.createElement("div", {
    className: "skeleton-bar"
  }), /*#__PURE__*/t.createElement("div", {
    className: "skeleton-bar"
  })));
}

un.propTypes = cn, un.defaultProps = {
  animate: !1
};
var dn = ["/", ",", ".", "-", "_", " "],
    mn = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];

function pn(e) {
  if (e) {
    var t = e.split("-"),
        n = s(t, 3),
        a = n[0],
        r = n[1],
        o = n[2];
    return new Date(a, parseInt(r) - 1, o);
  }
}

function fn(e) {
  return e.replaceAll("-", "/");
}

function vn(e) {
  if (!e || Number.isNaN(e.valueOf())) return "";
  var t = (e.getMonth() + 1).toString().padStart(2, "0"),
      n = e.getDate().toString().padStart(2, "0");
  return "".concat(e.getFullYear(), "-").concat(t, "-").concat(n);
}

function bn(e) {
  return Math.floor((e.getMonth() + 1) / 3);
}

function gn(e) {
  return Math.floor((e.getMonth() + 1) / 6);
}

function hn(e) {
  return new Date(e.getFullYear(), e.getMonth(), 1);
}

function yn(e) {
  return new Date(e.getFullYear(), 3 * bn(e), 1);
}

function En(e) {
  return new Date(e.getFullYear(), 6 * gn(e), 1);
}

function Nn(e) {
  return new Date(e.getFullYear(), 0, 1);
}

function wn(e) {
  return new Date(e.getFullYear(), e.getMonth() + 1, 0);
}

function xn(e) {
  return new Date(e.getFullYear(), 3 * (bn(e) + 1), 0);
}

function kn(e) {
  return new Date(e.getFullYear(), 6 * (gn(e) + 1), 0);
}

function Cn(e) {
  return new Date(e.getFullYear() + 1, 0, 0);
}

function Dn(e, t) {
  return !(!e || !t) && e.getFullYear() === t.getFullYear() && e.getMonth() === t.getMonth() && e.getDate() === t.getDate();
}

function On(e, t, n) {
  return !(!t || !n) && e.getTime() >= t.getTime() && e.getTime() <= n.getTime();
}

function Rn(e, t) {
  return e.getTime() > t.getTime() ? e : t;
}

function Tn(e, t) {
  return e.getTime() < t.getTime() ? e : t;
}

function Ln(e, t) {
  var n = new Date();
  if (Dn(n, t) && Dn(hn(n), e)) return "This Month";
  var a = new Date(n.getFullYear(), n.getMonth() - 1, 1);
  return Dn(a, e) && Dn(wn(a), t) ? "Last Month" : Dn(n, t) && Dn(yn(n), e) ? "QTD" : Dn(n, t) && Dn(Nn(n), e) ? "YTD" : Dn(Nn(e), e) && Dn(Cn(e), t) ? e.getFullYear().toString() : Dn(En(e), e) && Dn(kn(e), t) ? "H".concat(gn(e) + 1, " ").concat(e.getFullYear()) : Dn(yn(e), e) && Dn(xn(e), t) ? "Q".concat(bn(e) + 1, " ").concat(e.getFullYear()) : Dn(hn(e), e) && Dn(wn(e), t) ? e.toLocaleString("default", {
    month: "short",
    year: "numeric"
  }) : "".concat(fn(vn(e)), "-").concat(fn(vn(t)));
}

var Sn = {
  date: i.instanceOf(Date).isRequired,
  maxDate: i.instanceOf(Date).isRequired,
  minDate: i.instanceOf(Date).isRequired,
  onClick: i.func.isRequired,
  endDate: i.instanceOf(Date),
  startDate: i.instanceOf(Date)
},
    qn = {
  endDate: void 0,
  startDate: void 0
};

function In(e) {
  var n = e.date,
      a = e.endDate,
      r = e.maxDate,
      o = e.minDate,
      i = e.onClick,
      l = e.startDate,
      s = new Date(),
      c = Dn(n, s),
      u = n.getTime() > r.getTime() || n.getTime() < o.getTime(),
      d = (null == a ? void 0 : a.getTime()) >= (null == l ? void 0 : l.getTime()),
      m = (null == a ? void 0 : a.getTime()) <= r.getTime() && d,
      p = (null == l ? void 0 : l.getTime()) >= o.getTime(),
      f = Dn(n, a) && m,
      v = Dn(n, l) && p,
      b = On(n, l, a) && m && p,
      g = k("day-background", {
    "day-background--disabled": u,
    "day-background--end": f && b && !v,
    "day-background--selected": b && !f && !v,
    "day-background--start": v && b && !f
  }),
      h = k("t-body-2", "day-number", {
    "day-number--disabled": u,
    "day-number--today": c && !b && !v && !f,
    "day-number--selected": v && p || f && m
  });
  return /*#__PURE__*/t.createElement("button", {
    className: "day",
    disabled: u,
    type: "button",
    onClick: function () {
      u || i(n);
    }
  }, /*#__PURE__*/t.createElement("div", {
    className: g
  }, /*#__PURE__*/t.createElement("div", {
    className: h
  }, n.getDate())));
}

In.propTypes = Sn, In.defaultProps = qn;
var Pn = {
  margin: i.bool,
  vertical: i.bool
};

function An(e) {
  var n = e.margin,
      a = e.vertical,
      r = k("divider", {
    "divider--horizontal": !a,
    "divider--vertical": a,
    "divider--marginHorizontal": !a && n,
    "divider--marginVertical": a && n
  });
  return /*#__PURE__*/t.createElement("div", {
    className: r
  });
}

An.propTypes = Pn, An.defaultProps = {
  margin: !1,
  vertical: !1
};
var Un = {
  0: "January",
  1: "February",
  2: "March",
  3: "April",
  4: "May",
  5: "June",
  6: "July",
  7: "August",
  8: "September",
  9: "October",
  10: "November",
  11: "December"
},
    zn = ["MO", "TU", "WE", "TH", "FR", "SA", "SU"],
    Bn = {
  maxDate: i.instanceOf(Date).isRequired,
  minDate: i.instanceOf(Date).isRequired,
  setEndDate: i.func.isRequired,
  setStartDate: i.func.isRequired,
  endDate: i.instanceOf(Date),
  startDate: i.instanceOf(Date)
},
    Mn = {
  endDate: void 0,
  startDate: void 0
};

function Fn(e) {
  var o = e.maxDate,
      i = e.minDate,
      l = e.endDate,
      c = e.setEndDate,
      u = e.setStartDate,
      d = e.startDate,
      m = r(),
      p = r(),
      f = function (e, t) {
    for (var n = {}, a = hn(e), r = wn(t); a.getTime() <= r.getTime();) {
      var o,
          i = a.getFullYear(),
          l = a.getMonth(),
          s = a.getDate();
      n[i] || (n[i] = {}), (o = n[i])[l] || (o[l] = []), n[i][l].push(s), a.setDate(s + 1);
    }

    return n;
  }(i, o),
      v = new Date(),
      g = On(v, i, o),
      h = a((g ? v : o).getMonth()),
      y = s(h, 2),
      E = y[0],
      N = y[1],
      w = a(!1),
      x = s(w, 2),
      k = x[0],
      C = x[1],
      D = a(!1),
      O = s(D, 2),
      R = O[0],
      L = O[1],
      S = a((g ? v : o).getFullYear()),
      q = s(S, 2),
      I = q[0],
      A = q[1];

  n(function () {
    d && On(d, i, o) && (A(d.getFullYear()), N(d.getMonth()));
  }, [d]), n(function () {
    l && On(l, i, o) && (A(l.getFullYear()), N(l.getMonth()));
  }, [l]);
  var U = E - 1 in f[I] || I - 1 in f,
      z = E + 1 in f[I] || I + 1 in f,
      B = Object.keys(f).map(function (e) {
    return {
      label: e,
      onClick: function () {
        return function (e) {
          if (A(parseInt(e)), !f[e][E]) {
            var t = Object.keys(f[e])[0];
            N(parseInt(t));
          }
        }(e);
      },
      value: e
    };
  }),
      M = Object.keys(f[I]).map(function (e) {
    return {
      label: Un[e],
      onClick: function () {
        return N(parseInt(e));
      },
      value: e
    };
  });
  return /*#__PURE__*/t.createElement("div", {
    className: "calendar"
  }, /*#__PURE__*/t.createElement("div", {
    className: "calendar-navigation"
  }, /*#__PURE__*/t.createElement(P, {
    disabled: !U,
    iconLeft: "chevronLeft",
    variant: "round",
    onClick: function () {
      0 === E && A(function (e) {
        return e - 1;
      }), N(function (e) {
        return (e + 11) % 12;
      });
    }
  }), /*#__PURE__*/t.createElement("div", {
    className: "u-flexRow"
  }, /*#__PURE__*/t.createElement("button", {
    ref: m,
    className: "calendar-dropdown",
    type: "button",
    onClick: function () {
      return C(function (e) {
        return !e;
      });
    }
  }, Un[E], /*#__PURE__*/t.createElement(T, {
    name: "chevronDown"
  })), /*#__PURE__*/t.createElement(tn, {
    className: "calendar-menu",
    options: M,
    parentRef: m,
    show: k,
    onClose: function () {
      return C(!1);
    }
  }), /*#__PURE__*/t.createElement("button", {
    ref: p,
    className: "calendar-dropdown",
    type: "button",
    onClick: function () {
      return L(function (e) {
        return !e;
      });
    }
  }, I, /*#__PURE__*/t.createElement(T, {
    name: "chevronDown"
  })), /*#__PURE__*/t.createElement(tn, {
    className: "calendar-menu",
    options: B,
    parentRef: p,
    show: R,
    onClose: function () {
      return L(!1);
    }
  })), /*#__PURE__*/t.createElement(P, {
    disabled: !z,
    iconLeft: "chevronRight",
    variant: "round",
    onClick: function () {
      11 === E && A(function (e) {
        return e + 1;
      }), N(function (e) {
        return (e + 1) % 12;
      });
    }
  })), /*#__PURE__*/t.createElement(An, null), /*#__PURE__*/t.createElement("div", {
    className: "u-marginTop-8"
  }, /*#__PURE__*/t.createElement("div", {
    className: "calendar-grid"
  }, zn.map(function (e) {
    return /*#__PURE__*/t.createElement("div", {
      key: e,
      className: "calendar-header t-caption-1"
    }, e);
  }), function () {
    var e = (new Date(I, E, 1).getDay() + 6) % 7;
    return b(Array(e)).map(function (e, n) {
      return /*#__PURE__*/t.createElement("div", {
        key: n,
        className: "daySelection--offset"
      });
    });
  }(), f[I][E].map(function (e) {
    var n = new Date(I, E, e);
    return /*#__PURE__*/t.createElement(In, {
      key: e,
      date: n,
      endDate: l,
      maxDate: o,
      minDate: i,
      startDate: d,
      onClick: function () {
        return function (e) {
          d ? e.getTime() < d.getTime() || l ? (u(e), c(void 0)) : c(e) : u(e);
        }(n);
      }
    });
  }))));
}

Fn.propTypes = Bn, Fn.defaultProps = Mn;
var jn = {
  label: i.string.isRequired,
  onChange: i.func.isRequired,
  date: i.instanceOf(Date),
  isError: i.bool
},
    Yn = {
  date: void 0,
  isError: !1
};

function Gn(e) {
  return e ? e.getFullYear().toString() : "";
}

function Hn(e) {
  return e ? (e.getMonth() + 1).toString().padStart(2, "0") : "";
}

function Wn(e) {
  return e ? e.getDate().toString().padStart(2, "0") : "";
}

function Vn(e, t, n) {
  return e.length === "YYYY".length && t.length === "MM".length && n.length === "DD".length;
}

function _n(e) {
  var t = e.getBoundingClientRect().width;
  return {
    width: "".concat(t || 1, "px")
  };
}

function Kn(e) {
  return e.split("").reduce(function (t, n, a) {
    return dn.includes(n) || mn.includes(n) ? dn.includes(n) ? a + 1 === e.length && e.length > 1 ? [].concat(b(t), ["/"]) : t : [].concat(b(t), [n]) : t;
  }, []).join("");
}

function Xn(e) {
  var t = e.current;
  t && t.focus();
}

function Qn(e) {
  var o = e.date,
      i = e.isError,
      l = e.label,
      c = e.onChange,
      u = r(),
      d = r(),
      m = r(),
      p = r(),
      f = r(),
      v = r(),
      g = a(Wn(o)),
      h = s(g, 2),
      y = h[0],
      E = h[1],
      N = a(),
      w = s(N, 2),
      x = w[0],
      C = w[1],
      D = a(!0),
      O = s(D, 2),
      R = O[0],
      T = O[1],
      L = a(Hn(o)),
      S = s(L, 2),
      q = S[0],
      I = S[1],
      P = a(),
      A = s(P, 2),
      U = A[0],
      z = A[1],
      B = a(Gn(o)),
      M = s(B, 2),
      F = M[0],
      j = M[1],
      Y = a(),
      G = s(Y, 2),
      H = G[0],
      W = G[1],
      V = function (e) {
    e.preventDefault();
    var t,
        n = e.clipboardData.getData("text"),
        a = (t = n, t.split("").reduce(function (e, t) {
      return dn.includes(t) || mn.includes(t) ? dn.includes(t) ? [].concat(b(e), ["/"]) : [].concat(b(e), [t]) : e;
    }, []).join("")).split("/"),
        r = s(a, 3),
        o = r[0],
        i = r[1],
        l = r[2];
    j(o.slice(0, "YYYY".length)), I(i.padStart(2, "0").slice(0, "MM".length)), E(l.padStart(2, "0").slice(0, "DD".length));
  };

  n(function () {
    var e = d.current,
        t = p.current,
        n = v.current;
    return e.addEventListener("paste", V), t.addEventListener("paste", V), n.addEventListener("paste", V), function () {
      e.removeEventListener("paste", V), t.removeEventListener("paste", V), n.removeEventListener("paste", V);
    };
  }, []), n(function () {
    o ? (j(Gn(o)), I(Hn(o)), E(Wn(o))) : !o && Vn(F, q, y) && (j(""), I(""), E(""));
  }, [o]), n(function () {
    var e = f.current,
        t = m.current,
        n = u.current;
    e && W(_n(e)), t && z(_n(t)), n && C(_n(n));

    var a = Vn(F, q, y),
        r = function (e, t, n) {
      var a = parseInt(t);
      if (a < 1 || a > 12) return !1;
      var r = parseInt(n),
          o = new Date(e, a, 0).getDate();
      return !(r < 1 || r > o);
    }(F, q, y);

    if (a && r) {
      var i = new Date(F, parseInt(q - 1), y);
      Dn(o, i) || c(i);
    } else c(void 0);

    T(!a || r);
  }, [F, q, y]);

  var _ = function (e, t, n, a) {
    var r = e.target.selectionStart;
    "Backspace" !== e.key && "ArrowLeft" !== e.key || 0 !== r ? "ArrowRight" !== e.key && "/" !== e.key || r !== a || (Xn(n), e.preventDefault()) : (Xn(t), e.preventDefault());
  },
      K = k("t-body-1", "dateInput-container", {
    "dateInput-container--text": F || q || y,
    "dateInput-container--error": i || !R
  });

  return /*#__PURE__*/t.createElement("div", {
    className: "dateInput"
  }, /*#__PURE__*/t.createElement("label", null, /*#__PURE__*/t.createElement("div", {
    className: "dateInput-label t-caption-1"
  }, l), /*#__PURE__*/t.createElement("div", {
    className: K
  }, /*#__PURE__*/t.createElement("span", {
    ref: f,
    className: "dateInput-hidden"
  }, F), /*#__PURE__*/t.createElement("input", {
    ref: v,
    autoComplete: "off",
    className: "dateInput-input",
    maxLength: 4,
    style: H,
    type: "text",
    value: F,
    onChange: function (e) {
      var t = Kn(e.target.value);

      if ("/" === t.slice(-1)) {
        var n = t.slice(0, -1);
        2 === n.length ? (j("".concat("20").concat(n)), Xn(p)) : j(n);
      } else t.length === "YYYY".length ? (j(t), Xn(p)) : j(t);
    },
    onKeyDown: function (e) {
      return _(e, v, p, 4);
    }
  }), "YYYY".slice(F.length), /*#__PURE__*/t.createElement("span", null, "/"), /*#__PURE__*/t.createElement("span", {
    ref: m,
    className: "dateInput-hidden"
  }, q), /*#__PURE__*/t.createElement("input", {
    ref: p,
    autoComplete: "off",
    className: "dateInput-input",
    maxLength: 2,
    style: U,
    type: "text",
    value: q,
    onChange: function (e) {
      var t = Kn(e.target.value),
          n = parseInt(t);

      if ("/" === t.slice(-1)) {
        var a = t.slice(0, -1);
        1 === a.length && "0" !== a ? (I(a.padStart(2, "0")), Xn(d)) : I(a);
      } else n > 1 ? (I(t.padStart(2, "0")), Xn(d)) : t.length === "MM".length ? (I(t), Xn(d)) : I(t);
    },
    onKeyDown: function (e) {
      return _(e, v, d, 2);
    }
  }), "MM".slice(q.length), /*#__PURE__*/t.createElement("span", null, "/"), /*#__PURE__*/t.createElement("span", {
    ref: u,
    className: "dateInput-hidden"
  }, y), /*#__PURE__*/t.createElement("input", {
    ref: d,
    autoComplete: "off",
    className: "dateInput-input",
    maxLength: 2,
    style: x,
    type: "text",
    value: y,
    onChange: function (e) {
      var t = Kn(e.target.value),
          n = parseInt(t);

      if ("/" === t.slice(-1)) {
        var a = t.slice(0, -1);
        1 === a.length && "0" !== a ? E(a.padStart(2, "0")) : E(a);
      } else E(n > 3 ? t.padStart(2, "0") : t);
    },
    onKeyDown: function (e) {
      return _(e, p, d, 2);
    }
  }), "DD".slice(y.length))));
}

Qn.propTypes = jn, Qn.defaultProps = Yn;
var Jn = {
  dateHistory: i.arrayOf(i.shape({
    end: i.string,
    start: i.string
  })).isRequired,
  maxDate: i.instanceOf(Date).isRequired,
  minDate: i.instanceOf(Date).isRequired,
  setEndDate: i.func.isRequired,
  setStartDate: i.func.isRequired
};

function $n(e, t) {
  var n = new Date(),
      a = new Date(n.getFullYear(), n.getMonth() - 1),
      r = new Date(n.getFullYear() - 1, n.getMonth()),
      o = r.getFullYear(),
      i = new Date(o, 0),
      l = new Date(o, 6),
      s = new Date(o, 0),
      c = new Date(o, 3),
      u = new Date(o, 6),
      d = new Date(o, 9);
  return [{
    end: Tn(wn(n), t),
    label: "This Month",
    start: Rn(hn(n), e)
  }, {
    end: Tn(wn(a), t),
    label: "Last Month",
    start: Rn(hn(a), e)
  }, {
    end: Tn(Cn(n), t),
    label: "YTD",
    start: Rn(Nn(n), e)
  }, {
    end: Tn(xn(n), t),
    label: "QTD",
    start: Rn(yn(n), e)
  }].concat(b(function (e, t, n) {
    var a = e.getFullYear(),
        r = a.toString(),
        o = Math.floor((e.getMonth() + 1) / 3);
    return Array.from({
      length: o
    }).map(function (e, o) {
      var i = new Date(a, 3 * o, 1);
      return {
        end: Tn(xn(i), n),
        label: "Q".concat(o + 1, " ").concat(r),
        start: Rn(i, t)
      };
    });
  }(n, e, t)), [{
    end: Tn(Cn(r), t),
    label: r.getFullYear().toString(),
    start: Rn(Nn(r), e)
  }, {
    end: Tn(kn(l), t),
    label: "H2 ".concat(o),
    start: Rn(En(l), e)
  }, {
    end: Tn(kn(i), t),
    label: "H1 ".concat(o),
    start: Rn(En(i), e)
  }, {
    end: Tn(xn(d), t),
    label: "Q4 ".concat(o),
    start: Rn(yn(d), e)
  }, {
    end: Tn(xn(u), t),
    label: "Q3 ".concat(o),
    start: Rn(yn(u), e)
  }, {
    end: Tn(xn(c), t),
    label: "Q2 ".concat(o),
    start: Rn(yn(c), e)
  }, {
    end: Tn(xn(s), t),
    label: "Q1 ".concat(o),
    start: Rn(yn(s), e)
  }]);
}

function Zn(e, t, n) {
  return e.filter(function (e) {
    var a = e.end;
    return e.start >= t && a <= n;
  });
}

function ea(e) {
  var n = e.dateHistory,
      a = e.maxDate,
      r = e.minDate,
      o = e.setEndDate,
      i = e.setStartDate,
      l = Zn($n(r, a), r, a),
      s = n.map(function (e) {
    var t = e.end,
        n = e.start;
    return {
      end: pn(t),
      label: Ln(pn(n), pn(t)),
      start: pn(n)
    };
  }),
      c = Zn(s, r, a),
      u = function (e, n) {
    return e.map(function (e) {
      var a = e.end,
          r = e.label,
          o = e.start;
      return /*#__PURE__*/t.createElement("div", {
        key: "".concat(o, "_").concat(a, "_").concat(r),
        className: "dateTags-tag"
      }, /*#__PURE__*/t.createElement(ne, {
        label: r,
        onClick: function () {
          return n(o, a, r);
        }
      }));
    });
  };

  return /*#__PURE__*/t.createElement("div", {
    className: "dateTags"
  }, /*#__PURE__*/t.createElement("div", {
    className: "dateTags-label t-caption-1"
  }, "Quick Select"), /*#__PURE__*/t.createElement("div", {
    className: "dateTags-tags"
  }, u(l, function (e, t, n) {
    i(e, n), o(t, n);
  })), c.length > 0 && /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement("div", {
    className: "dateTags-label t-caption-1"
  }, "History"), /*#__PURE__*/t.createElement("div", {
    className: "dateTags-tags"
  }, u(c, function (e, t, n) {
    i(e), o(t);
  }))));
}

ea.propTypes = Jn;
var ta = {
  localStorageKey: i.string.isRequired,
  maxDate: i.instanceOf(Date).isRequired,
  minDate: i.instanceOf(Date).isRequired,
  parentRef: i.shape({
    current: i.instanceOf(Element)
  }).isRequired,
  position: i.oneOf(Xt).isRequired,
  setEndDate: i.func.isRequired,
  setRangeLabel: i.func.isRequired,
  setStartDate: i.func.isRequired,
  show: i.bool.isRequired,
  onClose: i.func.isRequired,
  onEndDateChange: i.func.isRequired,
  onStartDateChange: i.func.isRequired,
  endDate: i.instanceOf(Date),
  startDate: i.instanceOf(Date)
},
    na = {
  endDate: void 0,
  startDate: void 0
};

function aa(e, t, n) {
  return !e || !t || On(e, t, n);
}

function ra(e) {
  var r = e.endDate,
      o = e.localStorageKey,
      i = e.maxDate,
      l = e.minDate,
      c = e.onClose,
      u = e.onEndDateChange,
      p = e.onStartDateChange,
      f = e.parentRef,
      v = e.position,
      h = e.setEndDate,
      y = e.setRangeLabel,
      E = e.setStartDate,
      N = e.show,
      w = e.startDate,
      x = g(o, []),
      k = s(x, 2),
      C = k[0],
      D = k[1],
      O = a(aa(r, w, i)),
      R = s(O, 2),
      T = R[0],
      L = R[1],
      S = a(aa(w, l, i)),
      q = s(S, 2),
      I = q[0],
      A = q[1],
      U = a(null),
      z = s(U, 2),
      B = z[0],
      M = z[1],
      F = a(),
      j = s(F, 2),
      Y = j[0],
      G = j[1],
      H = function (e) {
    if (B) {
      var t = B.getBoundingClientRect(),
          n = e.clientX >= t.left && e.clientX <= t.right,
          a = e.clientY >= t.top && e.clientY <= t.bottom;
      if (n && a) return;
      c();
    }
  };

  n(function () {
    if (B) return document.addEventListener("click", H), function () {
      document.removeEventListener("click", H);
    };
  }, [B]), n(function () {
    L(aa(r, w, i)), A(aa(w, l, i));
  }, [r, w]);
  var W = T && I && r && w;
  d("Escape", c);
  var V = Ct(f.current, B, {
    modifiers: [{
      name: "offset",
      options: {
        offset: [0, 8]
      }
    }],
    placement: Zt(v)
  }),
      _ = V.styles,
      K = V.attributes;
  if (!N) return null;

  var X = function (e, t) {
    G(t), h(e);
  },
      Q = function (e, t) {
    G(t), E(e);
  };

  return /*#__PURE__*/t.createElement(Ot, null, /*#__PURE__*/t.createElement("div", m({
    ref: M,
    className: "u-elevation-1 datepickermenu",
    role: "menu",
    style: _.popper,
    tabIndex: -1
  }, K.popper), /*#__PURE__*/t.createElement("div", {
    className: "u-flexRow"
  }, /*#__PURE__*/t.createElement("div", {
    className: "datepickermenu-content"
  }, /*#__PURE__*/t.createElement(ea, {
    dateHistory: C,
    maxDate: i,
    minDate: l,
    setEndDate: X,
    setStartDate: Q
  })), /*#__PURE__*/t.createElement(An, {
    vertical: !0
  }), /*#__PURE__*/t.createElement("div", {
    className: "datepickermenu-content"
  }, /*#__PURE__*/t.createElement("div", {
    className: "u-flexRow u-gap-16"
  }, /*#__PURE__*/t.createElement(Qn, {
    date: w,
    isError: !I,
    label: "Start Date",
    onChange: Q
  }), /*#__PURE__*/t.createElement(Qn, {
    date: r,
    isError: !T,
    label: "End Date",
    onChange: X
  })), /*#__PURE__*/t.createElement(Fn, {
    endDate: r,
    maxDate: i,
    minDate: l,
    setEndDate: X,
    setStartDate: Q,
    startDate: w
  }), /*#__PURE__*/t.createElement("div", {
    className: "u-buttonGroup datepickermenu-buttons"
  }, /*#__PURE__*/t.createElement(P, {
    label: "Cancel",
    variant: "tertiary",
    onClick: c
  }), /*#__PURE__*/t.createElement(P, {
    disabled: !W,
    label: "Apply",
    onClick: function () {
      var e = vn(r),
          t = vn(w),
          n = {
        end: e,
        start: t
      },
          a = C.filter(function (n) {
        var a = n.end,
            r = n.start;
        return a !== e || r !== t;
      });
      D([n].concat(b(a)).slice(0, 5)), y(Y), u(e), p(t), c();
    }
  }))))));
}

ra.propTypes = ta, ra.defaultProps = na;
var oa = {
  maxDate: i.string.isRequired,
  minDate: i.string.isRequired,
  onEndDateChange: i.func.isRequired,
  onStartDateChange: i.func.isRequired,
  disabled: i.bool,
  endDate: i.string,
  localStorageKey: i.string,
  position: i.oneOf(Xt),
  startDate: i.string
},
    ia = {
  disabled: !1,
  endDate: void 0,
  localStorageKey: "cxDatePickerHistory",
  position: "bottom-right",
  startDate: void 0
};

function la(e) {
  var o = e.disabled,
      i = e.endDate,
      l = e.localStorageKey,
      c = e.maxDate,
      u = e.minDate,
      d = e.onEndDateChange,
      m = e.onStartDateChange,
      p = e.position,
      f = e.startDate,
      v = r(),
      b = pn(i),
      g = pn(f),
      h = pn(c),
      y = pn(u),
      E = a(),
      N = s(E, 2),
      w = N[0],
      x = N[1],
      C = a(b),
      D = s(C, 2),
      O = D[0],
      R = D[1],
      L = a(!1),
      S = s(L, 2),
      q = S[0],
      I = S[1],
      P = a(g),
      A = s(P, 2),
      U = A[0],
      z = A[1];
  n(function () {
    q && (R(b), z(g));
  }, [q]);
  var B = k("datepicker", {
    "datepicker--selected": q
  }),
      M = k("datepicker-label", {
    "datepicker-label--disabled": o
  });
  return /*#__PURE__*/t.createElement("div", {
    className: B
  }, /*#__PURE__*/t.createElement("button", {
    ref: v,
    "aria-expanded": q,
    className: "button datepicker-button",
    disabled: o,
    tabIndex: 0,
    type: "button",
    onClick: function () {
      return I(!q);
    }
  }, /*#__PURE__*/t.createElement("div", {
    className: "datepicker-content t-body-1"
  }, /*#__PURE__*/t.createElement(T, {
    name: "calendar"
  }), /*#__PURE__*/t.createElement("div", {
    className: M
  }, function (e, t, n) {
    return e || (t && n ? Ln(t, n) : "Date");
  }(w, g, b)), /*#__PURE__*/t.createElement(T, {
    name: "chevronDown"
  }))), /*#__PURE__*/t.createElement(ra, {
    endDate: O,
    localStorageKey: l,
    maxDate: h,
    minDate: y,
    parentRef: v,
    position: p,
    setEndDate: R,
    setRangeLabel: x,
    setStartDate: z,
    show: q,
    startDate: U,
    onClose: function () {
      return I(!1);
    },
    onEndDateChange: d,
    onStartDateChange: m
  }));
}

la.propTypes = oa, la.defaultProps = ia;
var sa = {
  children: i.node.isRequired,
  isOpen: i.bool.isRequired,
  onClose: i.func.isRequired
};

function ca(e) {
  var n = e.children,
      a = e.isOpen,
      r = e.onClose;
  d("Escape", r);
  var o = k("drawer", {
    "drawer--open": a
  });
  return /*#__PURE__*/t.createElement("div", {
    className: o
  }, n);
}

ca.propTypes = sa;
var ua = {
  label: i.string.isRequired,
  color: i.oneOf(["blue", "green", "grey", "orange", "purple", "red"]),
  icon: i.string
},
    da = {
  color: "grey",
  icon: void 0
};

function ma(e) {
  var n,
      a = e.label,
      r = e.color,
      o = e.icon,
      i = k("tag--regular", "t-body-1", "tag--".concat(r), {
    "tag--icon": o
  });
  return /*#__PURE__*/t.createElement("div", {
    className: "tag"
  }, /*#__PURE__*/t.createElement("div", {
    className: i
  }, (n = o) ? /*#__PURE__*/t.createElement("span", {
    className: "tag-icon"
  }, /*#__PURE__*/t.createElement(T, {
    color: "current",
    name: n
  })) : null, /*#__PURE__*/t.createElement("div", {
    className: "tag-label"
  }, a)));
}

ma.propTypes = ua, ma.defaultProps = da;
var pa = {
  disabled: i.bool,
  group: i.bool,
  label: i.string,
  testId: i.string,
  value: i.node
};

function fa(e, t, n) {
  var a = !1,
      r = !n,
      o = "".concat(r ? "MultiDropdown" : "Dropdown", " does not support");
  r ? "small" === t && (a = !0, o = "".concat(o, " menuProps.size = 'small'")) : "small" === t && "small" !== e && (a = !0, o = "".concat(o, " menuProps.size = 'small' when size = ").concat(e)), a && function (e) {
    "development" === process.env.NODE_ENV && console.warn(e);
  }(o);
}

var va = {
  options: i.arrayOf(i.shape(pa)).isRequired,
  disabled: i.bool,
  label: i.string,
  menuProps: i.shape({
    className: i.string,
    position: i.oneOf(Xt),
    size: i.oneOf(Qt)
  }),
  placeholder: i.string,
  size: i.oneOf(["small", "medium", "large"]),
  testId: i.string,
  onChange: i.func
},
    ba = h(h({}, va), {}, {
  selected: i.arrayOf(i.shape(pa)),
  single: i.bool,
  onSelectAll: i.func
}),
    ga = {
  disabled: !1,
  label: void 0,
  onChange: void 0,
  placeholder: "Select"
},
    ha = h(h({}, ga), {}, {
  menuProps: {
    className: void 0,
    position: "bottom-left",
    size: "medium"
  },
  onSelectAll: void 0,
  selected: [],
  single: !1,
  size: "medium"
});

function ya(e) {
  var n,
      o,
      i,
      l = e.disabled,
      c = e.label,
      u = e.menuProps,
      d = u.className,
      m = u.position,
      p = u.size,
      f = e.onChange,
      v = e.onSelectAll,
      b = e.options,
      g = e.placeholder,
      y = e.selected,
      E = e.single,
      N = e.size,
      w = e.testId;
  fa(N, p, E);
  var x,
      C,
      D,
      O = "".concat(c, "-menu"),
      R = r(),
      L = a(!1),
      S = s(L, 2),
      q = S[0],
      I = S[1],
      P = a(null),
      A = s(P, 2),
      U = A[0],
      z = A[1],
      B = !E,
      M = y.length,
      F = k("dropdown", {
    "dropdown--small": "small" === N,
    "dropdown--medium": "medium" === N,
    "dropdown--large": "large" === N,
    "dropdown--selected": q,
    "dropdown--withValue": M > 0
  }),
      j = b.map(function (e) {
    var t = y.findIndex(function (t) {
      var n = t.value;
      return e.value === n;
    }) > -1;
    return h(h({}, e), {}, {
      onClick: function () {
        f && f(e), E && I(!1);
      },
      selected: t
    });
  });

  if (v) {
    var Y = b.filter(function (e) {
      return !e.disabled;
    });
    j.unshift({
      label: "Select All",
      onClick: function () {
        M === Y.length ? null == v || v([]) : null == v || v(Y);
      },
      selected: M === Y.length
    });
  }

  return /*#__PURE__*/t.createElement("div", {
    className: F
  }, /*#__PURE__*/t.createElement("label", {
    className: "t-caption-1"
  }, c && /*#__PURE__*/t.createElement("div", {
    className: "dropdown-label"
  }, c), /*#__PURE__*/t.createElement("button", {
    ref: R,
    "aria-activedescendant": U,
    "aria-controls": O,
    "aria-expanded": q,
    "aria-haspopup": "menu",
    className: "dropdown-button button",
    "data-testid": w,
    disabled: l,
    role: "combobox",
    tabIndex: 0,
    type: "button",
    onClick: function () {
      return I(!q);
    }
  }, /*#__PURE__*/t.createElement("div", {
    className: "dropdown-content t-body-1"
  }, /*#__PURE__*/t.createElement("div", {
    className: "u-flexRow u-gap-8 u-alignCenter"
  }, (null === (n = y[0]) || void 0 === n ? void 0 : n.icon) && /*#__PURE__*/t.createElement(T, {
    name: y[0].icon,
    noWrapper: !0
  }), null !== (o = null === (i = y[0]) || void 0 === i ? void 0 : i.label) && void 0 !== o ? o : g, " "), (C = (x = M) > 1, D = x - 1, /*#__PURE__*/t.createElement("div", {
    className: "dropdown-tag"
  }, C && /*#__PURE__*/t.createElement(ma, {
    label: "+".concat(D)
  }), /*#__PURE__*/t.createElement(T, {
    name: "chevronDown",
    noWrapper: !0
  })))))), /*#__PURE__*/t.createElement(tn, {
    className: d,
    id: O,
    label: c,
    multiple: B,
    options: j,
    parentRef: R,
    position: m,
    search: b.length >= 12,
    show: q,
    size: p,
    onActiveDescendantChange: z,
    onClose: function () {
      return I(!1);
    }
  }));
}

ya.propTypes = ba, ya.defaultProps = ha;
var Ea = h(h({}, va), {}, {
  selected: i.shape(pa)
}),
    Na = h(h({}, ga), {}, {
  menuProps: {
    className: void 0,
    position: "bottom-left",
    size: "small"
  },
  selected: void 0,
  size: "small"
});

function wa(e) {
  var n = e.selected ? [e.selected] : [];
  return /*#__PURE__*/t.createElement(ya, m({}, e, {
    selected: n,
    single: !0
  }));
}

wa.propTypes = Ea, wa.defaultProps = Na;
var xa = {
  label: i.string.isRequired,
  section: i.string,
  url: i.string
},
    ka = {
  section: void 0,
  url: void 0
};

function Ca(e) {
  var n = e.label,
      a = e.section,
      r = e.url;
  return /*#__PURE__*/t.createElement("div", {
    className: "header"
  }, /*#__PURE__*/t.createElement("div", {
    className: "t-label-1"
  }, r && function (e, n) {
    return /*#__PURE__*/t.createElement("a", {
      className: "header-link",
      href: n
    }, /*#__PURE__*/t.createElement(T, {
      name: "chevronLeft"
    }), /*#__PURE__*/t.createElement("span", null, e));
  }(a, r), !r && function (e) {
    return /*#__PURE__*/t.createElement("div", {
      "aria-level": "1",
      className: "header-section",
      role: "heading"
    }, e);
  }(a)), /*#__PURE__*/t.createElement("h4", null, /*#__PURE__*/t.createElement(_t, {
    size: "custom",
    text: n,
    breakAll: !0
  })));
}

Ca.propTypes = xa, Ca.defaultProps = ka;
var Da = {
  name: i.string.isRequired
},
    Oa = {
  creativexLogo: "creativexLogo",
  creativexLogoGrey: "creativexLogoGrey",
  sideNavImage: "sideNavImage"
};

function Ra(e) {
  var n = e.name,
      a = Oa[n];
  return /*#__PURE__*/t.createElement("span", {
    className: "image"
  }, /*#__PURE__*/t.createElement("svg", {
    height: "100%",
    width: "100%"
  }, /*#__PURE__*/t.createElement("use", {
    xlinkHref: "#image-".concat(a)
  })));
}

Ra.propTypes = Da;
var Ta = {
  name: i.string.isRequired
},
    La = {
  adform: "adform",
  adwords: "adwords",
  amazon: "amazon",
  canto: "canto",
  dv360: "dv360",
  facebook: "facebook",
  fashionTv: "fashionTv",
  google: "google",
  iqiyi: "iqiyi",
  instagram: "instagram",
  mangoTv: "mangoTv",
  meta: "meta",
  mytarget: "mytarget",
  pinterest: "pinterest",
  pptv: "pptv",
  snapchat: "snapchat",
  sohu: "sohu",
  tencent: "tencent",
  toutiao: "toutiao",
  tiktok: "tiktok",
  tv: "tv",
  twitter: "twitter",
  wechat: "wechat",
  weibo: "weibo",
  xiaomi: "xiaomi",
  youku: "youku",
  youtube: "youtube"
};

function Sa(e) {
  var n,
      a = e.name,
      r = null !== (n = La[a]) && void 0 !== n ? n : "defaultPlaceholder";
  return /*#__PURE__*/t.createElement("span", {
    className: "logo"
  }, /*#__PURE__*/t.createElement("svg", {
    "aria-label": "".concat(a, " logo"),
    height: "100%",
    role: "img",
    width: "100%"
  }, /*#__PURE__*/t.createElement("use", {
    xlinkHref: "#logo-".concat(r)
  })));
}

Sa.propTypes = Ta;
var qa = {
  isOpen: i.bool.isRequired,
  title: i.string.isRequired,
  onActionButtonClick: i.func.isRequired,
  onClose: i.func.isRequired,
  actionButtonActive: i.bool,
  actionButtonDisabled: i.bool,
  actionButtonLabel: i.string,
  actionButtonVariant: i.oneOf(L),
  children: i.node,
  closeButtonLabel: i.string,
  size: i.oneOf(G),
  subtitle: i.string
},
    Ia = {
  actionButtonActive: !1,
  actionButtonDisabled: !1,
  actionButtonLabel: "Continue",
  actionButtonVariant: "primary",
  children: void 0,
  closeButtonLabel: "Cancel",
  size: "medium",
  subtitle: void 0
};

function Pa(e) {
  var n = e.actionButtonActive,
      a = e.actionButtonDisabled,
      r = e.actionButtonLabel,
      o = e.actionButtonVariant,
      i = e.children,
      l = e.closeButtonLabel,
      s = e.isOpen,
      c = e.onActionButtonClick,
      u = e.onClose,
      d = e.size,
      m = e.subtitle,
      p = e.title,
      f = /*#__PURE__*/t.createElement("div", {
    className: "dsmodal-title"
  }, /*#__PURE__*/t.createElement("div", null, p && /*#__PURE__*/t.createElement("h4", null, p), m && /*#__PURE__*/t.createElement("div", {
    className: "t-subtitle"
  }, m)), /*#__PURE__*/t.createElement(oe, {
    onClick: u
  })),
      v = /*#__PURE__*/t.createElement("div", {
    className: "dsmodal-buttons"
  }, /*#__PURE__*/t.createElement(P, {
    label: l,
    variant: "tertiary",
    onClick: u
  }), /*#__PURE__*/t.createElement(Y, {
    active: n,
    disabled: a,
    label: r,
    variant: o,
    onClick: c
  }));
  return /*#__PURE__*/t.createElement(V, {
    footer: v,
    header: f,
    isOpen: s,
    size: d,
    onClose: u
  }, i);
}

function Aa(e, t) {
  var n = {
    currency: "USD",
    maximumFractionDigits: t ? 2 : 0,
    style: "currency"
  };
  return new Intl.NumberFormat("en-US", n).format(e);
}

function Ua(e, t) {
  switch (t) {
    case "currency":
      return Aa(e, !1);

    case "decimalCurrency":
      return Aa(e, !0);

    case "number":
      return function (e) {
        return new Intl.NumberFormat("en-US", {
          style: "decimal",
          maximumFractionDigits: 0
        }).format(e);
      }(e);

    case "percentage":
      return function (e) {
        return new Intl.NumberFormat("en-US", {
          style: "percent",
          maximumFractionDigits: 0
        }).format(e);
      }(e);

    default:
      throw new Error("formatText: Unknown format");
  }
}

Pa.propTypes = qa, Pa.defaultProps = Ia;
var za = {
  metric: i.shape({
    caption: i.string,
    delta: i.number,
    format: i.string,
    label: i.string,
    tooltip: i.string,
    value: i.oneOfType([i.number, i.string])
  }).isRequired,
  alert: i.bool,
  lookback: i.number,
  lookbackUnit: i.string,
  url: i.string,
  onClick: i.func
},
    Ba = {
  alert: !0,
  lookback: 30,
  lookbackUnit: "days",
  onClick: void 0,
  url: void 0
};

function Ma(e, n, a) {
  var r = e.caption,
      o = e.delta,
      i = e.format,
      l = e.label,
      s = e.tooltip,
      c = e.value,
      u = "string" == typeof c ? c : Ua(c, i || "number");
  return /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement("div", {
    className: "metricCard-label"
  }, a && /*#__PURE__*/t.createElement("div", {
    className: "alert-icon"
  }, /*#__PURE__*/t.createElement(T, {
    color: "red",
    name: "exclamationCircle"
  })), /*#__PURE__*/t.createElement(_t, {
    className: "t-label-1",
    text: l
  }), s && /*#__PURE__*/t.createElement(Ht, {
    label: s
  })), /*#__PURE__*/t.createElement("div", {
    className: "metricCard-metric"
  }, /*#__PURE__*/t.createElement("h1", null, u), function (e, n, a) {
    var r, o;
    if (void 0 !== e) return 0 === e ? o = "No change" : e > 0 && (o = Ua(e, "number"), r = "arrowUp"), /*#__PURE__*/t.createElement("div", {
      className: "metricCard-delta"
    }, /*#__PURE__*/t.createElement(ma, {
      color: a && e > 0 ? "red" : void 0,
      icon: r,
      label: "".concat(o, " in the last ").concat(n.number, " ").concat(n.unit)
    }));
  }(o, n, a)), /*#__PURE__*/t.createElement("div", {
    className: "metricCard-caption"
  }, /*#__PURE__*/t.createElement("caption", {
    className: "t-caption-1"
  }, r)));
}

function Fa(e) {
  var n = e.alert,
      a = e.lookback,
      r = e.lookbackUnit,
      i = e.metric,
      l = e.onClick,
      s = e.url,
      c = s ? "a" : o,
      u = {
    number: a,
    unit: r
  };
  return /*#__PURE__*/t.createElement(c, function (e, t) {
    if (!e) return {};
    var n = {
      href: e
    };
    return t && (n.onClick = t), n;
  }(s, l), /*#__PURE__*/t.createElement(X, {
    className: "metricCard"
  }, /*#__PURE__*/t.createElement("div", {
    className: "metricCard-content"
  }, Ma(i, u, n)), s && /*#__PURE__*/t.createElement(T, {
    name: "chevronRight"
  })));
}

Fa.propTypes = za, Fa.defaultProps = Ba;
var ja = {
  isOpen: i.bool.isRequired,
  onActionButtonClick: i.func.isRequired,
  onClose: i.func.isRequired,
  actionButtonActive: i.bool,
  actionButtonDisabled: i.bool,
  actionButtonLabel: i.string,
  actionButtonVariant: i.oneOf(L),
  ariaLabel: i.string,
  children: i.node,
  closeButtonLabel: i.string,
  size: i.oneOf(G)
},
    Ya = {
  actionButtonActive: !1,
  actionButtonDisabled: !1,
  actionButtonLabel: "Continue",
  actionButtonVariant: "primary",
  ariaLabel: "Modal",
  children: void 0,
  closeButtonLabel: "Cancel",
  size: void 0
};

function Ga(e) {
  var n = e.actionButtonActive,
      a = e.actionButtonDisabled,
      r = e.actionButtonLabel,
      o = e.actionButtonVariant,
      i = e.ariaLabel,
      l = e.children,
      s = e.closeButtonLabel,
      c = e.isOpen,
      u = e.onActionButtonClick,
      d = e.onClose,
      m = e.size,
      p = /*#__PURE__*/t.createElement(oe, {
    onClick: d
  }),
      f = /*#__PURE__*/t.createElement("div", {
    className: "dsmodal-buttons"
  }, /*#__PURE__*/t.createElement(P, {
    label: s,
    variant: "tertiary",
    onClick: d
  }), /*#__PURE__*/t.createElement(Y, {
    active: n,
    disabled: a,
    label: r,
    variant: o,
    onClick: u
  }));
  return /*#__PURE__*/t.createElement(V, {
    ariaLabel: i,
    footer: f,
    header: p,
    isOpen: c,
    size: m,
    onClose: d
  }, l);
}

Ga.propTypes = ja, Ga.defaultProps = Ya;
var Ha = {
  options: i.arrayOf(i.shape(Kt)).isRequired,
  disabled: i.bool,
  menuPosition: i.oneOf(Xt),
  menuSize: i.oneOf(Qt),
  testId: i.string
},
    Wa = {
  disabled: !1,
  menuPosition: "bottom-right",
  menuSize: "medium",
  testId: void 0
};

function Va(e) {
  var n = e.disabled,
      o = e.menuPosition,
      i = e.menuSize,
      l = e.options,
      c = e.testId,
      u = r(),
      d = a(!1),
      m = s(d, 2),
      p = m[0],
      f = m[1];
  return /*#__PURE__*/t.createElement("div", {
    className: "moreButton"
  }, /*#__PURE__*/t.createElement("div", {
    ref: u
  }, /*#__PURE__*/t.createElement(P, {
    ariaExpanded: p,
    ariaLabel: "More options",
    disabled: n,
    iconLeft: "moreDots",
    testId: c,
    variant: "round",
    onClick: function () {
      return f(!p);
    }
  })), /*#__PURE__*/t.createElement(tn, {
    options: l,
    parentRef: u,
    position: o,
    show: p,
    size: i,
    onClose: function () {
      return f(!1);
    }
  }));
}

Va.propTypes = Ha, Va.defaultProps = Wa;

var _a = i.shape({
  companyName: i.string.isRequired,
  fullName: i.string.isRequired,
  logoUrl: i.string
}),
    Ka = i.shape({
  label: i.string.isRequired,
  url: i.string.isRequired
}),
    Xa = {
  options: i.arrayOf(Ka).isRequired,
  user: _a.isRequired
};

function Qa(e) {
  var n,
      o = e.options,
      i = e.user,
      l = r(),
      c = a(!1),
      u = s(c, 2),
      d = u[0],
      m = u[1];
  return /*#__PURE__*/t.createElement("div", {
    className: "navFooter"
  }, /*#__PURE__*/t.createElement("div", {
    className: "navFooter-logo"
  }, (n = i.logoUrl) ? /*#__PURE__*/t.createElement("img", {
    alt: "Company Logo",
    className: "navFooter-image",
    src: n
  }) : /*#__PURE__*/t.createElement(Ra, {
    name: "sideNavImage"
  })), /*#__PURE__*/t.createElement("div", {
    className: "navFooter-names"
  }, /*#__PURE__*/t.createElement("div", {
    className: "t-caption-1 u-marginBottom-8 navFooter-text"
  }, /*#__PURE__*/t.createElement(_t, {
    size: "custom",
    text: i.fullName
  })), /*#__PURE__*/t.createElement("div", {
    className: "t-caption-1 navFooter-text"
  }, /*#__PURE__*/t.createElement(_t, {
    size: "custom",
    text: i.companyName
  }))), /*#__PURE__*/t.createElement("button", {
    ref: l,
    "aria-label": "Navigation options",
    className: "navFooter-button",
    type: "button",
    onClick: function () {
      return m(!d);
    }
  }, /*#__PURE__*/t.createElement(T, {
    color: "current",
    name: "moreDots"
  })), /*#__PURE__*/t.createElement(tn, {
    options: o,
    parentRef: l,
    position: "top-right",
    show: d,
    onClose: function () {
      return m(!1);
    }
  }));
}

Qa.propTypes = Xa;
var Ja = {
  homeUrl: i.string.isRequired,
  color: i.string
};

function $a(e) {
  var n = e.color,
      a = e.homeUrl;
  return /*#__PURE__*/t.createElement("div", {
    className: "navHeader"
  }, /*#__PURE__*/t.createElement("a", {
    "aria-label": "Creative X: Go to Home Page",
    className: "navHeader-link",
    href: a
  }, /*#__PURE__*/t.createElement(Ra, {
    name: "purple" === n ? "creativexLogo" : "creativexLogoGrey"
  })));
}

function Za() {
  return /*#__PURE__*/t.createElement("svg", {
    height: "0",
    width: "0"
  }, /*#__PURE__*/t.createElement("defs", null, /*#__PURE__*/t.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "navGradient--company",
    x1: "11",
    x2: "17",
    y1: "23.5",
    y2: "-0.999999"
  }, /*#__PURE__*/t.createElement("stop", {
    stopColor: "var(--white)"
  }), /*#__PURE__*/t.createElement("stop", {
    offset: "1",
    stopColor: "var(--purple-400)"
  })), /*#__PURE__*/t.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "navGradient--connections",
    x1: "8.5",
    x2: "21.5858",
    y1: "24.5",
    y2: "-2.45835"
  }, /*#__PURE__*/t.createElement("stop", {
    stopColor: "var(--purple-400)"
  }), /*#__PURE__*/t.createElement("stop", {
    offset: "1",
    stopColor: "var(--white)"
  })), /*#__PURE__*/t.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "navGradient--creatives",
    x1: "11",
    x2: "17",
    y1: "23.5",
    y2: "-0.999999"
  }, /*#__PURE__*/t.createElement("stop", {
    stopColor: "var(--white)"
  }), /*#__PURE__*/t.createElement("stop", {
    offset: "1",
    stopColor: "var(--purple-400)"
  })), /*#__PURE__*/t.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "navGradient--dashboard",
    x1: "18.5",
    x2: "6.39465",
    y1: "0.5",
    y2: "23.9456"
  }, /*#__PURE__*/t.createElement("stop", {
    stopColor: "var(--purple-400)"
  }), /*#__PURE__*/t.createElement("stop", {
    offset: "1",
    stopColor: "var(--white)"
  })), /*#__PURE__*/t.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "navGradient--guidelines",
    x1: "10.6731",
    x2: "10.7671",
    y1: "2.74451",
    y2: "24.0012"
  }, /*#__PURE__*/t.createElement("stop", {
    stopColor: "var(--purple-400)"
  }), /*#__PURE__*/t.createElement("stop", {
    offset: "1",
    stopColor: "var(--white)"
  })), /*#__PURE__*/t.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "navGradient--preflight",
    x1: "20",
    x2: "7.78931",
    y1: "2.50006",
    y2: "23.171"
  }, /*#__PURE__*/t.createElement("stop", {
    stopColor: "var(--purple-400)"
  }), /*#__PURE__*/t.createElement("stop", {
    offset: "1",
    stopColor: "var(--white)"
  })), /*#__PURE__*/t.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "navGradient--productionEfficiency",
    x1: "3.5",
    x2: "21.838",
    y1: "19",
    y2: "8.06698"
  }, /*#__PURE__*/t.createElement("stop", {
    stopColor: "var(--purple-400)"
  }), /*#__PURE__*/t.createElement("stop", {
    offset: "1",
    stopColor: "var(--white)"
  })), /*#__PURE__*/t.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "navGradient--reporting",
    x1: "13",
    x2: "12.251",
    y1: "20",
    y2: "-0.00939636"
  }, /*#__PURE__*/t.createElement("stop", {
    stopColor: "var(--purple-400)"
  }), /*#__PURE__*/t.createElement("stop", {
    offset: "1",
    stopColor: "var(--white)"
  })), /*#__PURE__*/t.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "navGradient--settings",
    x1: "3.5",
    x2: "21.838",
    y1: "19",
    y2: "8.06698"
  }, /*#__PURE__*/t.createElement("stop", {
    stopColor: "var(--purple-400)"
  }), /*#__PURE__*/t.createElement("stop", {
    offset: "1",
    stopColor: "var(--white)"
  })), /*#__PURE__*/t.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "navGradient--userPreferences",
    x1: "4.49999",
    x2: "24.6064",
    y1: "21",
    y2: "1.61034"
  }, /*#__PURE__*/t.createElement("stop", {
    stopColor: "var(--purple-400)"
  }), /*#__PURE__*/t.createElement("stop", {
    offset: "1",
    stopColor: "var(--white)"
  }))));
}

function er(e, t, n) {
  var a = new URL(e, "https://app.creativex.com");
  return a.pathname === t && b(a.searchParams.entries()).every(function (e) {
    var t = s(e, 2),
        a = t[0],
        r = t[1];
    return n.get(a) === r;
  });
}

$a.propTypes = Ja, $a.defaultProps = {
  color: "purple"
};
var tr = {
  currentParams: i.string.isRequired,
  currentUrl: i.string.isRequired,
  label: i.string.isRequired,
  urls: i.arrayOf(i.string).isRequired,
  locked: i.bool,
  useNewTab: i.bool
};

function nr(e) {
  var n = e.currentParams,
      a = e.currentUrl,
      r = e.label,
      o = e.locked,
      i = e.urls,
      l = e.useNewTab,
      s = new URLSearchParams(n),
      c = i.some(function (e) {
    return er(e, a, s);
  }),
      u = k("t-label-1", "navOption", "navOption--default", {
    "navOption--current": c
  });
  return o ? /*#__PURE__*/t.createElement("div", {
    className: "t-label-1 navOption navOption--locked",
    role: "listitem"
  }, /*#__PURE__*/t.createElement("div", null, r), /*#__PURE__*/t.createElement("div", {
    className: "navOption-lock"
  }, /*#__PURE__*/t.createElement(T, {
    name: "lock"
  }), /*#__PURE__*/t.createElement("div", {
    className: "t-subtitle navOption-tooltip"
  }, "You do not have permission to view this page. Contact your admin or email us at support@creativex.com"))) : 0 === i.length ? null : /*#__PURE__*/t.createElement("div", {
    role: "listitem"
  }, /*#__PURE__*/t.createElement("a", {
    key: r,
    className: u,
    href: i[0],
    rel: l ? "noreferrer" : "",
    target: l ? "_blank" : ""
  }, r));
}

nr.propTypes = tr, nr.defaultProps = {
  locked: !1,
  useNewTab: !1
};
var ar = {
  children: i.oneOfType([i.arrayOf(i.node), i.node]).isRequired,
  className: i.string.isRequired,
  expanded: i.bool.isRequired,
  onClick: i.func.isRequired,
  url: i.string
},
    rr = {
  url: void 0
};

function or(e) {
  var n = e.children,
      a = e.className,
      r = e.expanded,
      o = e.onClick,
      i = e.url;
  return i ? /*#__PURE__*/t.createElement("a", {
    className: a,
    href: i
  }, n) : /*#__PURE__*/t.createElement("button", {
    "aria-expanded": r,
    className: a,
    type: "button",
    onClick: o
  }, n);
}

or.propTypes = ar, or.defaultProps = rr;
var ir = i.shape({
  label: i.string.isRequired,
  urls: i.arrayOf(i.string).isRequired,
  locked: i.bool
}),
    lr = {
  currentParams: i.string.isRequired,
  currentSection: i.string.isRequired,
  currentUrl: i.string.isRequired,
  icon: i.string.isRequired,
  label: i.string.isRequired,
  openSections: i.arrayOf(i.string).isRequired,
  options: i.arrayOf(ir).isRequired,
  onClick: i.func.isRequired,
  color: i.string
};

function sr(e) {
  var n,
      a = e.color,
      r = e.currentParams,
      i = e.currentSection,
      l = e.currentUrl,
      s = e.icon,
      c = e.label,
      u = e.onClick,
      d = e.openSections,
      m = e.options,
      p = i === c,
      f = 1 === m.length,
      v = !f && d.includes(c),
      b = f ? null === (n = m[0]) || void 0 === n ? void 0 : n.urls[0] : null,
      g = k("navSection-icon", y({}, "navGradient--".concat(s), p && "purple" === a)),
      h = k("navSection", {
    "navSection--current": p,
    "navSection--highlighted": p && !v
  }),
      E = k("navSection-chevron", {
    "navSection-chevron--current": p
  }),
      N = v ? "chevronUp" : "chevronDown";
  return 0 === m.length ? null : /*#__PURE__*/t.createElement(o, {
    key: c
  }, /*#__PURE__*/t.createElement(or, {
    className: h,
    expanded: v,
    url: b,
    onClick: u
  }, /*#__PURE__*/t.createElement("span", {
    className: g
  }, /*#__PURE__*/t.createElement(T, {
    color: "current",
    name: s
  })), /*#__PURE__*/t.createElement("div", {
    className: "navSection-label"
  }, /*#__PURE__*/t.createElement("span", null, c), !f && /*#__PURE__*/t.createElement("div", {
    className: E
  }, /*#__PURE__*/t.createElement(T, {
    color: "current",
    name: N
  })))), /*#__PURE__*/t.createElement("div", {
    className: "u-flexRow"
  }, /*#__PURE__*/t.createElement("div", {
    className: "navSection-spacer"
  }), /*#__PURE__*/t.createElement("div", {
    className: "navSection-options",
    role: "list"
  }, v && m.map(function (e) {
    return /*#__PURE__*/t.createElement(nr, {
      key: e.label,
      currentParams: r,
      currentUrl: l,
      label: e.label,
      locked: e.locked,
      urls: e.urls,
      useNewTab: e.useNewTab
    });
  }))));
}

sr.propTypes = lr, sr.defaultProps = {
  color: "purple"
};
var cr = i.shape({
  icon: i.string.isRequired,
  label: i.string.isRequired,
  options: i.arrayOf(ir).isRequired,
  onClick: i.func
}),
    ur = {
  currentParams: i.string.isRequired,
  currentUrl: i.string.isRequired,
  menu: i.arrayOf(cr).isRequired,
  color: i.string
};

function dr(e) {
  var a = e.color,
      r = e.currentParams,
      o = e.currentUrl,
      i = e.menu,
      l = function (e, t, n) {
    var a,
        r = new URLSearchParams(t),
        o = n.find(function (t) {
      return t.options.some(function (t) {
        return t.urls.some(function (t) {
          return er(t, e, r);
        });
      });
    });
    return null !== (a = null == o ? void 0 : o.label) && void 0 !== a ? a : "";
  }(o, r, i),
      c = g("cxNavOpenSections", [l]),
      u = s(c, 2),
      d = u[0],
      m = u[1];

  n(function () {
    m([l]);
  }, []);
  return /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement("div", {
    className: "navMenu"
  }, i.map(function (e) {
    var n = e.icon,
        i = e.label,
        s = e.options,
        c = e.onClick;
    return /*#__PURE__*/t.createElement(sr, {
      key: i,
      color: a,
      currentParams: r,
      currentSection: l,
      currentUrl: o,
      icon: n,
      label: i,
      openSections: d,
      options: s,
      onClick: function () {
        return function (e, t) {
          t && t(), d.includes(e) ? m(d.filter(function (t) {
            return t !== e;
          })) : m([].concat(b(d), [e]));
        }(i, c);
      }
    });
  })), /*#__PURE__*/t.createElement(Za, null));
}

dr.propTypes = ur, dr.defaultProps = {
  color: "purple"
};
var mr = i.shape({
  icon: i.string.isRequired,
  label: i.string.isRequired,
  options: i.arrayOf(ir).isRequired
}),
    pr = {
  currentParams: i.string.isRequired,
  currentUrl: i.string.isRequired,
  homeUrl: i.string.isRequired,
  menu: i.arrayOf(mr).isRequired,
  user: _a.isRequired,
  userOptions: i.arrayOf(Ka).isRequired,
  color: i.string
};

function fr(e) {
  var n = e.color,
      a = e.currentParams,
      r = e.currentUrl,
      o = e.homeUrl,
      i = e.menu,
      l = e.user,
      s = e.userOptions,
      c = k("t-body-1", "nav", "nav-layout", "nav--".concat(n));
  return /*#__PURE__*/t.createElement("div", {
    className: c
  }, /*#__PURE__*/t.createElement("div", {
    className: "nav-header"
  }, /*#__PURE__*/t.createElement($a, {
    color: n,
    homeUrl: o
  })), /*#__PURE__*/t.createElement("div", {
    className: "nav-menu"
  }, /*#__PURE__*/t.createElement(dr, {
    color: n,
    currentParams: a,
    currentUrl: r,
    menu: i
  })), /*#__PURE__*/t.createElement("div", {
    className: "nav-footer"
  }, /*#__PURE__*/t.createElement(Qa, {
    options: s,
    user: l
  })));
}

fr.propTypes = pr, fr.defaultProps = {
  color: "purple"
};
var vr = {
  children: i.node.isRequired,
  ariaLabel: i.string,
  disabled: i.bool,
  isStatic: i.bool,
  selected: i.bool,
  onClick: i.func
},
    br = {
  ariaLabel: "",
  disabled: !1,
  isStatic: !1,
  onClick: void 0,
  selected: !1
};

function gr(e) {
  var n = e.ariaLabel,
      a = e.children,
      r = e.disabled,
      o = e.isStatic,
      i = e.onClick,
      l = e.selected;
  if (o) return /*#__PURE__*/t.createElement("div", {
    className: "pageToken pageToken--static"
  }, a);
  var s = k("pageToken", {
    "pageToken--selected": l
  });
  return /*#__PURE__*/t.createElement("button", {
    "aria-label": n,
    className: s,
    disabled: r,
    type: "button",
    onClick: i
  }, a);
}

function hr(e, t) {
  return void 0 !== e.find(function (e) {
    return e.value === t.value;
  });
}

function yr(e, t) {
  return e.filter(function (e) {
    return e.value !== t.value;
  });
}

function Er(e, t) {
  var n = e.findIndex(function (e) {
    return e.value === t.value;
  });
  return n > -1 ? [].concat(b(e.slice(0, n)), b(e.slice(n + 1))) : [].concat(b(e), [t]);
}

gr.propTypes = vr, gr.defaultProps = br;
var Nr = {
  currentPage: i.number.isRequired,
  perPage: i.number.isRequired,
  onPageChange: i.func.isRequired,
  total: i.number
},
    wr = {
  total: void 0
};

function xr(e, n, a, r) {
  return /*#__PURE__*/t.createElement(gr, {
    ariaLabel: r,
    disabled: n,
    onClick: a
  }, /*#__PURE__*/t.createElement(T, {
    color: "current",
    name: e
  }));
}

function kr(e, t) {
  var n = function (e, t) {
    var n = t - e + 1;
    return Array.from({
      length: n
    }, function (t, n) {
      return e + n;
    });
  }(e, t);

  return n.map(function (e) {
    return {
      value: e
    };
  });
}

function Cr(e, n, a) {
  var r = function (e, t) {
    if (t < 8) return kr(1, t);
    var n = [{
      value: 1
    }, {
      isStatic: !0,
      text: "...",
      value: "ellipses_0"
    }],
        a = [{
      isStatic: !0,
      text: "...",
      value: "ellipses_1"
    }, {
      value: t
    }];
    return e < 5 ? kr(1, 5).concat(a) : e > t - 4 ? n.concat(kr(t - 4, t)) : n.concat(kr(e - 1, e + 1), a);
  }(e, a);

  return r.map(function (a) {
    var r = a.isStatic,
        o = a.text,
        i = a.value;
    return /*#__PURE__*/t.createElement(gr, {
      key: "pageToken_".concat(i),
      isStatic: r,
      selected: i === e,
      onClick: function () {
        return n(i);
      }
    }, null != o ? o : i);
  });
}

function Dr(e) {
  var n = e.currentPage,
      a = e.onPageChange,
      r = e.perPage,
      o = e.total,
      i = o > 0,
      l = i && Math.ceil(o / r),
      s = 1 === n,
      c = n === l,
      u = 1 !== l;
  return /*#__PURE__*/t.createElement("div", {
    className: "pagination"
  }, u && xr("chevronLeftDouble", s, function () {
    return a(1);
  }, "First page"), u && xr("chevronLeft", s, function () {
    return a(n - 1);
  }, "Previous page"), u && Cr(n, a, l), u && xr("chevronRight", c, function () {
    return a(n + 1);
  }, "Next page"), u && i && xr("chevronRightDouble", c, function () {
    return a(l);
  }, "Last page"), function (e, n, a, r, o) {
    var i = n * (e - 1) + 1,
        l = r ? Math.min(n * e, a) : n * e,
        s = "t-body-1 pagination-results ".concat(o ? "pagination-margin" : "");
    return /*#__PURE__*/t.createElement("div", {
      className: s
    }, /*#__PURE__*/t.createElement("span", null, "".concat(i, " - ").concat(l)), r && /*#__PURE__*/t.createElement("span", null, " of ".concat(a, " Results")));
  }(n, r, o, i, u));
}

Dr.propTypes = Nr, Dr.defaultProps = wr;
var Or = {
  name: i.string.isRequired,
  value: i.string.isRequired,
  ariaLabel: i.string,
  checked: i.bool,
  disabled: i.bool,
  label: i.node,
  testId: i.string,
  tooltip: i.string,
  onChange: i.func
},
    Rr = {
  ariaLabel: "",
  checked: !1,
  disabled: !1,
  label: void 0,
  onChange: void 0,
  testId: void 0,
  tooltip: void 0
};

function Tr(e) {
  var n = e.ariaLabel,
      a = e.checked,
      r = e.disabled,
      o = e.label,
      i = e.name,
      l = e.onChange,
      s = e.testId,
      c = e.tooltip,
      u = e.value,
      d = k("radio", "t-label-1", {
    "radio--disabled": r
  });
  return /*#__PURE__*/t.createElement("label", {
    className: d
  }, /*#__PURE__*/t.createElement("div", {
    className: "radio-box"
  }, /*#__PURE__*/t.createElement("input", {
    "aria-label": n || o || "Radio",
    checked: a,
    className: "radio-input",
    "data-testid": s,
    disabled: r,
    name: i,
    type: "radio",
    value: u,
    onChange: l
  }), /*#__PURE__*/t.createElement("div", {
    className: "radio-hover"
  }), /*#__PURE__*/t.createElement("div", {
    className: "radio-focus"
  }), /*#__PURE__*/t.createElement("div", {
    className: "radio-ring"
  }), /*#__PURE__*/t.createElement("div", {
    className: "radio-check"
  })), /*#__PURE__*/t.createElement("div", {
    className: "radio-label"
  }, o, c && /*#__PURE__*/t.createElement(Ht, {
    label: c
  })));
}

Tr.propTypes = Or, Tr.defaultProps = Rr;
var Lr = {
  name: i.string.isRequired,
  options: i.arrayOf(i.shape({
    value: i.string.isRequired,
    disabled: i.bool,
    label: i.node,
    testId: i.string,
    tooltip: i.string
  })).isRequired,
  horizontal: i.bool,
  label: i.node,
  value: i.string,
  onChange: i.func
},
    Sr = {
  horizontal: !1,
  label: void 0,
  onChange: void 0,
  value: void 0
};

function qr(e) {
  var n = e.horizontal,
      a = e.label,
      r = e.name,
      o = e.onChange,
      i = e.options,
      l = e.value,
      s = k("radioGroup-radios", {
    "radioGroup-radios--horizontal": n
  });
  return /*#__PURE__*/t.createElement("div", {
    className: "radioGroup"
  }, /*#__PURE__*/t.createElement("label", null, a && /*#__PURE__*/t.createElement("div", {
    className: "radioGroup-label t-caption-1"
  }, a), /*#__PURE__*/t.createElement("div", {
    className: s
  }, i.map(function (e) {
    var n = e.disabled,
        a = e.label,
        i = e.testId,
        s = e.tooltip,
        c = e.value;
    return /*#__PURE__*/t.createElement(Tr, {
      key: c,
      checked: l === c,
      disabled: n,
      label: a,
      name: r,
      testId: i,
      tooltip: s,
      value: c,
      onChange: o
    });
  }))));
}

qr.propTypes = Lr, qr.defaultProps = Sr;
var Ir = h({
  header: i.string.isRequired
}, _),
    Pr = h({}, K);

function Ar(e) {
  var n = e.children,
      a = e.header,
      r = e.padding;
  return /*#__PURE__*/t.createElement("div", {
    className: "sectionCard"
  }, /*#__PURE__*/t.createElement("h5", null, a), /*#__PURE__*/t.createElement(X, {
    padding: r
  }, n));
}

Ar.propTypes = Ir, Ar.defaultProps = Pr;
var Ur = {
  step: i.number.isRequired,
  label: i.string
},
    zr = {
  currentStep: i.number.isRequired,
  steps: i.arrayOf(i.shape(Ur)).isRequired
};

function Br(e) {
  var n = e.currentStep,
      a = e.steps;
  return /*#__PURE__*/t.createElement("div", {
    className: "stepper stepper-container"
  }, a.map(function (e, a) {
    var r = e.step,
        o = e.label;
    return /*#__PURE__*/t.createElement(t.Fragment, {
      key: r
    }, a > 0 && function (e, n) {
      var a = k("stepper-spacer", {
        "stepper-spacer--active": e <= n
      });
      return /*#__PURE__*/t.createElement("div", {
        className: a
      });
    }(r, n), function (e, n, a) {
      var r = e < n,
          o = k("stepper-step", {
        "stepper-step--active": e === n,
        "stepper-step--complete": r,
        "stepper-step--disabled": e > n,
        "stepper-step--without-label": !a
      }),
          i = r ? /*#__PURE__*/t.createElement(T, {
        color: "white",
        name: "check"
      }) : /*#__PURE__*/t.createElement("div", null, e);
      return /*#__PURE__*/t.createElement("div", {
        className: o
      }, /*#__PURE__*/t.createElement("div", {
        className: "stepper-step-content t-label-1"
      }, i), a && /*#__PURE__*/t.createElement("div", {
        className: "stepper-step-label t-label-1"
      }, a));
    }(r, n, o));
  }));
}

Br.propTypes = zr;
var Mr = {
  value: i.node.isRequired,
  className: i.string,
  colSpan: i.number,
  sortLabel: i.string
},
    Fr = {
  value: i.node.isRequired,
  className: i.string,
  colSpan: i.number,
  key: i.string
},
    jr = {
  className: i.string,
  headers: i.arrayOf(i.oneOfType([i.shape(Mr), i.arrayOf(i.shape(Mr))])),
  rows: i.arrayOf(i.shape({
    cells: i.arrayOf(i.shape(Fr)).isRequired,
    key: i.string.isRequired
  }))
},
    Yr = {
  className: void 0,
  headers: [],
  rows: []
};

function Gr(e) {
  var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
  return /*#__PURE__*/t.createElement("tr", {
    key: n
  }, e.map(function (e, n) {
    return /*#__PURE__*/t.createElement("th", {
      key: n,
      "aria-sort": e.sortLabel || "none",
      className: e.className,
      colSpan: e.colSpan,
      role: "columnheader"
    }, e.value);
  }));
}

function Hr(e) {
  var n = e.className,
      a = e.headers,
      r = e.rows,
      o = k("dsTable", n);
  return /*#__PURE__*/t.createElement("div", {
    className: o
  }, /*#__PURE__*/t.createElement("table", null, /*#__PURE__*/t.createElement("thead", {
    className: "t-overline"
  }, function (e) {
    return 0 === e.length ? null : Array.isArray(e[0]) ? e.map(Gr) : Gr(e);
  }(a)), /*#__PURE__*/t.createElement("tbody", {
    className: "t-body-1"
  }, function (e) {
    return 0 === e.length ? null : e.map(function (e) {
      var n = e.key,
          a = e.cells;
      return /*#__PURE__*/t.createElement("tr", {
        key: n
      }, a.map(function (e, n) {
        var a;
        return /*#__PURE__*/t.createElement("td", {
          key: null !== (a = e.key) && void 0 !== a ? a : n,
          className: e.className,
          colSpan: e.colSpan || 1
        }, e.value);
      }));
    });
  }(r))));
}

Hr.propTypes = jr, Hr.defaultProps = Yr;
var Wr = {
  animate: i.bool
};

function Vr() {
  return /*#__PURE__*/t.createElement("div", {
    className: "u-flexColumn u-gap-16"
  }, /*#__PURE__*/t.createElement("div", {
    className: "skeleton-bar"
  }), /*#__PURE__*/t.createElement("div", {
    className: "skeleton-bar"
  }), /*#__PURE__*/t.createElement("div", {
    className: "skeleton-bar"
  }), /*#__PURE__*/t.createElement("div", {
    className: "skeleton-bar"
  }), /*#__PURE__*/t.createElement("div", {
    className: "skeleton-bar"
  }), /*#__PURE__*/t.createElement("div", {
    className: "skeleton-bar"
  }));
}

function _r(e) {
  var n = e.animate,
      a = k("skeleton--table", {
    "skeleton--table--animated": n
  });
  return /*#__PURE__*/t.createElement("div", {
    className: "skeleton"
  }, /*#__PURE__*/t.createElement("div", {
    className: a
  }, Vr(), Vr(), Vr(), Vr()));
}

_r.propTypes = Wr, _r.defaultProps = {
  animate: !1
};
var Kr = i.shape({
  label: i.string.isRequired,
  icon: i.string,
  iconColor: i.string,
  testId: i.string,
  tooltip: i.string,
  url: i.string,
  onClick: i.func
}),
    Xr = {
  tabs: i.arrayOf(Kr).isRequired,
  currentParams: i.string,
  currentTab: i.string,
  currentUrl: i.string,
  showSingleTab: i.bool,
  variant: i.oneOf(["link", "button"])
},
    Qr = {
  currentParams: void 0,
  currentTab: void 0,
  currentUrl: void 0,
  showSingleTab: !1,
  variant: "link"
};

function Jr(e, t) {
  if (e) {
    var n = new URL(e, "https://app.creativex.com"),
        a = function (e, t) {
      var n = new URLSearchParams();
      return b(e.entries()).map(function (e) {
        var t = s(e, 2),
            a = t[0],
            r = t[1];
        return n.set(a, r);
      }), b(t.entries()).map(function (e) {
        var t = s(e, 2),
            a = t[0],
            r = t[1];
        return n.set(a, r);
      }), n;
    }(t, n.searchParams).toString();

    return "".concat(n.pathname).concat(a ? "?" : "").concat(a);
  }
}

function $r(e) {
  var n,
      a,
      r = e.icon,
      o = e.iconColor,
      i = e.label,
      l = e.tooltip;
  return /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement("div", {
    className: "tabs-focus"
  }), (a = o, (n = r) ? /*#__PURE__*/t.createElement("div", {
    className: "tabs-icon"
  }, /*#__PURE__*/t.createElement(T, {
    color: a,
    name: n
  })) : null), i, l && /*#__PURE__*/t.createElement(Ht, {
    label: l
  }));
}

function Zr(e, n, a, r, o) {
  var i = e.label,
      l = e.url,
      s = k("tabs-line", {
    "tabs-line--selected": function () {
      if ("link" === o) {
        var e = new URLSearchParams(n);
        return er(l, a, e);
      }

      return r === i;
    }()
  });
  return /*#__PURE__*/t.createElement("div", {
    key: i,
    className: "tabs-tab"
  }, function (e, n, a, r, o) {
    var i = e.label,
        l = e.onClick,
        s = e.testId,
        c = e.url,
        u = $r(e),
        d = function () {
      l && l(i);
    };

    if ("link" === o) {
      var m = new URLSearchParams(n);
      return /*#__PURE__*/t.createElement("a", {
        className: "tabs-element",
        "data-testid": s,
        href: Jr(c, m),
        onClick: d
      }, u);
    }

    return /*#__PURE__*/t.createElement("button", {
      "aria-label": "".concat(i, " tab"),
      "aria-pressed": r === i,
      className: "tabs-element",
      "data-testid": s,
      type: "button",
      onClick: d
    }, u);
  }(e, n, 0, r, o), /*#__PURE__*/t.createElement("div", {
    className: s
  }));
}

function eo(e) {
  var n = e.currentParams,
      a = e.currentTab,
      r = e.currentUrl,
      o = e.showSingleTab,
      i = e.tabs,
      l = e.variant;
  return i.length <= 1 && !o ? null : /*#__PURE__*/t.createElement("div", {
    className: "tabs"
  }, i.map(function (e) {
    return Zr(e, n, r, a, l);
  }));
}

eo.propTypes = Xr, eo.defaultProps = Qr;
var to = {
  value: i.string.isRequired,
  onChange: i.func.isRequired,
  disabled: i.bool,
  form: i.string,
  label: i.node,
  maxLength: i.number,
  minLength: i.number,
  name: i.string,
  placeholder: i.string,
  required: i.bool,
  size: i.oneOf(["small", "medium", "large"]),
  testId: i.string
},
    no = {
  disabled: !1,
  form: void 0,
  label: void 0,
  maxLength: void 0,
  minLength: void 0,
  name: void 0,
  placeholder: void 0,
  required: !1,
  size: "small",
  testId: void 0
};

function ao(e) {
  var n = e.disabled,
      a = e.form,
      r = e.label,
      o = e.maxLength,
      i = e.minLength,
      l = e.name,
      s = e.onChange,
      c = e.placeholder,
      u = e.required,
      d = e.size,
      m = e.testId,
      p = e.value,
      f = k("textArea-input", "t-body-1", {
    "textArea-input--small": "small" === d,
    "textArea-input--medium": "medium" === d,
    "textArea-input--large": "large" === d
  });
  return /*#__PURE__*/t.createElement("div", {
    className: "textArea"
  }, /*#__PURE__*/t.createElement("label", {
    className: "u-flexColumn"
  }, r && /*#__PURE__*/t.createElement("div", {
    className: "textArea-label t-caption-1"
  }, r), /*#__PURE__*/t.createElement("textarea", {
    autoComplete: "off",
    className: f,
    "data-testid": m,
    disabled: n,
    form: a,
    maxLength: o,
    minLength: i,
    name: l,
    placeholder: c,
    required: u,
    spellCheck: !1,
    value: p,
    onChange: function (e) {
      return s(e.target.value);
    }
  })));
}

ao.propTypes = to, ao.defaultProps = no;
var ro = {
  message: i.string.isRequired,
  onClose: i.func.isRequired,
  size: i.oneOf(["small", "medium", "large"]),
  testId: i.string,
  type: i.oneOf(["success", "warning", "error"])
},
    oo = {
  size: "medium",
  testId: void 0,
  type: "success"
};

function io(e) {
  var n = e.message,
      a = e.onClose,
      r = e.size,
      o = e.testId,
      i = e.type,
      l = k("toast", "u-elevation-1", {
    "toast--small": "small" === r,
    "toast--medium": "medium" === r,
    "toast--large": "large" === r
  });
  return /*#__PURE__*/t.createElement("div", {
    className: l
  }, /*#__PURE__*/t.createElement("div", {
    className: "toast-icon"
  }, /*#__PURE__*/t.createElement(T, function (e) {
    switch (e) {
      case "success":
        return {
          color: "green",
          name: "checkCircle"
        };

      case "warning":
        return {
          color: "orange",
          name: "exclamationTriangle"
        };

      case "error":
        return {
          color: "red",
          name: "exclamationCircle"
        };

      default:
        return;
    }
  }(i))), /*#__PURE__*/t.createElement("div", {
    "aria-live": "assertive",
    className: "toast-message t-label-1"
  }, n), /*#__PURE__*/t.createElement("div", {
    className: "toast-icon"
  }, /*#__PURE__*/t.createElement(oe, {
    testId: o,
    onClick: a
  })));
}

io.propTypes = ro, io.defaultProps = oo;
var lo = {
  ariaLabel: i.string,
  checked: i.bool,
  disabled: i.bool,
  label: i.node,
  name: i.string,
  right: i.bool,
  testId: i.string,
  onChange: i.func
},
    so = {
  ariaLabel: "",
  checked: !1,
  disabled: !1,
  label: void 0,
  name: void 0,
  onChange: void 0,
  right: !1,
  testId: void 0
};

function co(e) {
  var n = e.ariaLabel,
      a = e.checked,
      r = e.disabled,
      o = e.label,
      i = e.name,
      l = e.onChange,
      s = e.right,
      c = e.testId,
      u = k("toggle", "t-label-1", {
    "toggle--disabled": r
  });
  return /*#__PURE__*/t.createElement("label", {
    className: u
  }, !s && o, /*#__PURE__*/t.createElement("div", {
    className: "toggle-box"
  }, /*#__PURE__*/t.createElement("input", {
    key: "toggle-input",
    "aria-label": n || o || "Toggle",
    checked: a,
    className: "toggle-input",
    "data-testid": c,
    disabled: r,
    name: i,
    type: "checkbox",
    onChange: l
  }), /*#__PURE__*/t.createElement("div", {
    className: "toggle-switch"
  }), /*#__PURE__*/t.createElement("div", {
    className: "toggle-focus"
  })), s && o);
}

co.propTypes = lo, co.defaultProps = so;
export { Y as ActionButton, z as AddNewButton, V as BasicModal, P as Button, X as Card, $ as Checkbox, ne as ClickableTag, oe as CloseButton, rn as ComboButton, sn as CopyButton, un as DataVizSkeleton, la as DatePicker, An as Divider, ca as Drawer, wa as Dropdown, Ca as Header, T as Icon, Ra as Image, Sa as Logo, _t as MaxWidthText, tn as Menu, Pa as MessageModal, Fa as MetricCard, Ga as Modal, Va as MoreButton, ya as MultipleDropdown, fr as Nav, Qa as NavFooter, $a as NavHeader, dr as NavMenu, Dr as Pagination, Tr as Radio, qr as RadioGroup, Ft as Search, Ar as SectionCard, M as Spinner, Br as Stepper, Hr as Table, _r as TableSkeleton, eo as Tabs, ma as Tag, ao as TextArea, zt as TextInput, io as Toast, co as Toggle, Ht as Tooltip, vn as dateToString, hr as findObjectByValue, Ua as formatText, er as matchUrls, yr as removeObjectByValue, Ma as renderMetric, pn as stringToDate, Er as toggleObject };